// Extra strings for TurnosIA module and sidebar items not covered in pt.js
const messages = {
  pt: {
    translations: {
      support: {
        "menu": "Suporte",
        "title": "Suporte",
        "subtitle": "Conte sua dúvida ou reclamação e responderemos aqui, nesta mesma tela.",
        "company": "Empresa",
        "yourQuery": "Sua consulta",
        "placeholder": "Conte o que você precisa ou o que aconteceu, com o máximo de detalhes possível…",
        "counter": "{{count}} / {{max}}",
        "privacy": "Não cole mensagens dos seus clientes ou pacientes: o texto da consulta é processado por um provedor de IA.",
        "ticketLabel": "ID do ticket (opcional)",
        "ticketPrefilled": "Ticket #{{id}}",
        "contactLabel": "Contato",
        "connectionLabel": "Conexão (opcional)",
        "connectionNone": "Nenhuma",
        "removeTicket": "Remover ticket",
        "attach": "Anexar captura",
        "pasteImage": "Colar imagem",
        "pasteHint": "Você também pode colar uma imagem com Ctrl+V (Cmd+V no Mac).",
        "pasteUnsupported": "Seu navegador não permite colar imagens com o botão. Use Ctrl+V (Cmd+V) ou anexe a captura.",
        "newReply": "Nova resposta",
        "pasteDenied": "Você não deu permissão para ler a área de transferência. Tente Ctrl+V (Cmd+V) ou anexe a captura.",
        "pasteNoImage": "Não há nenhuma imagem na área de transferência.",
        "imagesCount": "{{count}} de {{max}} imagens",
        "removeImage": "Remover imagem",
        "openImage": "Ampliar imagem",
        "closeImage": "Fechar",
        "errType": "Só são aceitas imagens PNG, JPG ou WebP.",
        "errSize": "Cada imagem pode ter até 5 MB.",
        "errCount": "Você pode anexar até 3 imagens.",
        "send": "Enviar",
        "sending": "Enviando…",
        "sentOk": "Consulta enviada. Número #{{id}}.",
        "legend": "A resposta aparece nesta tela; um número vermelho no menu Suporte avisa que há uma resposta nova.",
        "myQueries": "Suas consultas",
        "empty": "Você ainda não enviou nenhuma consulta.",
        "loadMore": "Ver mais",
        "loadError": "Não foi possível carregar suas consultas.",
        "refresh": "Atualizar",
        "loading": "Carregando…",
        "bubbleMine": "Sua consulta",
        "bubbleOurs": "Nossa resposta",
        "bubbleClarify": "Precisamos de mais dados",
        "replyPlaceholder": "Escreva sua resposta…",
        "replySend": "Responder",
        "replyHelp": "Precisamos de mais algum dado para ajudar. Responda neste mesmo fio.",
        "closedNote": "Esta consulta está encerrada.",
        "copyId": "Copiar número",
        "idCopied": "ID copiado",
        "idCopyFailed": "Não foi possível copiar o ID.",
        "buttonLabel": "Suporte",
        "buttonTooltip": "Consultar o Suporte sobre este ticket (copia o ID)",
        "draftKept": "Seu rascunho é mantido enquanto você navega.",
        "ticketNote": "Ticket #{{id}}",
        "status": {
          "recibida": "Recebida",
          "necesita_datos": "Precisamos de mais dados",
          "en_revision": "Em revisão",
          "borrador_listo": "Em revisão",
          "respondida": "Respondida",
          "cerrada": "Encerrada",
          "borde": "Em revisão",
          "pasada_checklist": "Em revisão",
          "resuelta_checklist": "Respondida"
        }
      },
      crmBoard: {
        cardActions: "Ações",
        openInChat: "Abrir no chat",
        transfer: "Transferir",
        transferClosedHint: "Conversa encerrada: reabra-a primeiro para transferi-la.",
        noTicket: "Este contato não tem conversa.",
        entryBadge: "Entrada",
        entryTooltip: "Etapa de entrada: aqui aparecem os contatos com conversa que ainda não têm etapa.",
        noEntryText: "Os contatos que ainda não têm etapa não aparecem no Funnel. Escolha uma etapa de entrada para vê-los.",
        noEntryTextUser: "Os contatos que ainda não têm etapa não aparecem no Funnel. Um administrador pode escolher uma etapa de entrada em Estados de Contato.",
        noEntryAction: "Escolher etapa de entrada",
        title: "Funnel",
        noState: "Sem estado",
        inactiveTooltip: "Estado desativado: mostra os contatos que ainda o têm, mas não é possível soltar contatos aqui.",
        inactiveBadge: "Desativado",
        loadMore: "Ver mais",
        emptyColumn: "Sem contatos",
        unassigned: "Sem atribuição",
        searchPlaceholder: "Buscar contato…",
        dateFrom: "Último contato desde",
        dateTo: "Até",
        clearFilters: "Limpar filtros",
        refresh: "Atualizar",
        loadError: "Não foi possível carregar o Funnel.",
        moveError: "Não foi possível mudar o estado. O contato voltou para sua coluna.",
        closedAuto: "O chat do contato foi fechado (fechamento automático).",
        noMessages: "Sem mensagens",
        openTickets: "Chats abertos: {{count}}",
        prefixAdvisor: "Atendente: ",
        prefixAi: "IA: ",
        prefixSystem: "Sistema: ",
        timeNow: "agora",
        timeMinutes: "{{count}} min",
        timeHours: "{{count}} h",
        timeDays: "{{count}} d",
        openChatError: "Não foi possível abrir o chat.",
        disabledTitle: "O Funnel não está ativado",
        disabledText: "Um administrador pode ativá-lo em Estados de Contato.",
        needsStatesTitle: "Não há estados de contato ativos",
        needsStatesText: "Ative pelo menos um estado em Estados de Contato para usar o Funnel.",
        goToStates: "Ir para Estados de Contato",
        historyTitle: "Histórico de estados",
        historyEmpty: "Ainda não há mudanças registradas.",
        historyApi: "API",
        historyBoard: "Funnel",
        historyUnknownUser: "Sistema",
        historyLoadError: "Não foi possível carregar o histórico.",
        historyMore: "Ver mais",
      },
      contactStateModal: {
        title: "Mudar estado do contato",
        lostTitle: "Por que foi perdido?",
        otherReason: "Outro motivo",
        otherReasonLabel: "Especificar motivo",
        cancel: "Cancelar",
        back: "Voltar",
        confirm: "Confirmar",
        noState: "Sem estado",
        chipTooltip: "Etapa no processo comercial",
      },
      // feat_315 — formato fecha/hora tipo WhatsApp (fmtSmartTimestamp)
      smartTimestamp: {
        yesterday: "Ontem",
        today: "Hoje",
      },
      loginPage: {
        sections: {
          waia: {
            nav: "WAIA",
            title: "Que atender pelo WhatsApp deixe de tomar seu dia todo",
            chip1: "Caixa compartilhada",
            chip2: "IA que responde",
            chip3: "Multiempresa",
          },
          turnosia: {
            nav: "TurnosIA",
            title: "Agendamentos pelo WhatsApp, sem faltas",
            chip1: "Lista de espera IA",
            chip2: "Lembretes",
            chip3: "Tela de sala de espera",
          },
          integraciones: {
            nav: "Integrações",
            title: "Conecte suas ferramentas",
            chip1: "Google Sheets",
            chip2: "CRMs",
            chip3: "Webhooks · n8n",
            chip4: "API própria",
          },
        },
        metaBadge: "Provedor de tecnologia verificado — Meta",
      },
      turnosChat: {
        iaPaused: "IA pausada",
        keepAttending: "Continuar atendendo",
        closeDialogTitle: "Fechar chat de agendamentos",
        closeDialogBody: "Deseja devolver a conversa à IA ou deixá-la em atendimento humano?",
        returnToIa: "Sim, devolver à IA",
        keepHuman: "Deixar em atendimento humano",
        continueAttending: "Continuar atendendo",
        iaResumed: "A IA retomou a conversa",
        badgeActive: "TurnosIA",
        sessionError: "Não foi possível gerenciar a sessão de agendamentos",
      },
      floatingChat: {
        moreActions: "Mais ações",
        openInChat: "Abrir no chat",
        transfer: "Transferir",
        transferredTo: "Chat transferido para {{name}}.",
        notOpenPending: "Este chat está em espera. Atenda-o para poder escrever.",
        notOpenClosed: "Este chat está fechado. Reabra-o para poder escrever.",
        sendTemplate: "Enviar modelo",
        hideTemplate: "Cancelar",
        otherOpenTicket:
          "Já existe uma conversa aberta com este contato. Abra-a em Chats para escrever; o modelo não foi enviado.",
        resize: "Redimensionar",
        minimize: "Minimizar",
        close: "Fechar",
        openFloating: "Abrir em janela flutuante",
        errorOpening: "Não foi possível abrir o chat",
        loadError: "Não foi possível carregar esta conversa.",
        loadErrorDenied: "Você não tem permissão para abrir este chat (o ticket não está em nenhuma das suas filas).",
        retry: "Tentar de novo",
        loading: "Carregando conversa…",
        via: "via",
        lineNotAllowed:
          "Não foi possível abrir o chat nessa linha (não pertence à sua empresa ou não existe).",
      },
      templateOverrides: {
        loading: "Carregando modelos…",
        sectionTitle: "Modelo Meta por mensagem (fora das 24 h)",
        qrLine: "A linha do TurnosIA é QR (texto livre): não usa modelos Meta.",
        noLine: "Esta empresa não tem uma linha Meta do TurnosIA configurada.",
        intro:
          "Escolha qual modelo Meta aprovado cada mensagem usa fora da janela de 24 h. Só são oferecidos os compatíveis em variáveis. Sem escolha = o modelo por convenção.",
        vars: "variáveis",
        useDefault: "Usar o de convenção",
        incompatible: "incompatível",
        backToDefault: "Voltar ao padrão",
        mapped: "Mapeado para",
        usingConvention: "Usa a convenção",
        marketingWarning:
          "É um modelo MARKETING numa mensagem transacional: a Meta pode bloqueá-lo ou o cliente marcá-lo como spam.",
        noneCompatible:
          "Não há modelos aprovados compatíveis (mesmo número de variáveis) para esta mensagem.",
        saveError: "Não foi possível salvar o mapeamento.",
        useLabel: "Fora das 24 h, usar:",
        metaSubsectionTitle: "Fora das 24 h (modelo Meta)",
        notCreated: "ainda não criado/aprovado na Meta",
        noPreview: "Sem pré-visualização para este modelo.",
        noMeta: "Esta mensagem sai sempre como texto livre na conversa (sem modelo Meta).",
        stApproved: "Aprovado",
        stPending: "Em revisão",
        stRejected: "Rejeitado",
        showExample: "Ver com dados de exemplo",
        hideExample: "Ver com nomes de variável",
        reminderFuture: "Com antecedência (mais de 12 h antes)",
        reminderToday: "No dia do agendamento (12 h ou menos)",
      },
      panel: {
        title: "Painel geral",
        refresh: "Atualizar",
        summary: {
          messages2h: "Mensagens 2h",
          openTickets: "Tickets abertos",
          activeCompanies: "Empresas ativas",
          usersOnline: "Usuários online",
          totalCompanies: "Empresas totais",
        },
        system: {
          disk: "Disco",
          mem: "Memória",
          load: "Carga",
          public: "Mídia",
          uptime: "Uptime",
          error: "erro ao medir",
        },
        companies: "Empresas",
        search: "Buscar por nome, slug, ID, usuário, email ou notas…",
        filterAll: "Todas",
        col: {
          id: "ID",
          name: "Nome",
          status: "Estado",
          usersOnline: "Online",
          whatsapp: "WA",
          messages7d: "Msg 7d",
          actions: "Ações",
        },
        actions: {
          edit: "Editar",
          impersonate: "Ver como",
          clear: "Limpar dados",
          create: "Criar empresa",
          advanced: "Configuração avançada",
          users: "Gerenciar usuários",
          viewAsAdmin: "Ver como admin",
          viewAsUser: "Ver como usuário específico",
        },
        notesLabel: "Notas (só superadmin)",
        editTitle: "Editar empresa",
        createTitle: "Criar empresa",
        adminSection: "Usuário administrador inicial (opcional)",
        selfRegistration: "Permitir registro de empresas (signup público)",
        online: "Online",
      },
      operationStatus: {
        active: "Ativa",
        paused: "Pausada",
        blocked: "Bloqueada",
        waiting_meta: "Aguardando Meta",
        demo: "Demo",
        trial: "Teste",
      },
      aiAssistantStats: {
        menu: "Estatísticas IA",
        tooltips: {
          horasAhorradas:
            "Estimativa do tempo de atendimento que a IA poupou à equipe. É calculada a partir da quantidade de conversas e de um tempo estimado de atendimento por conversa. É um valor estimado, que vamos refinando.",
          cobertura:
            "Porcentagem de respostas que a IA deu fora do horário de atendimento humano —à noite ou no fim de semana—, quando uma pessoa não teria respondido na hora. É medida sobre as conversas respondidas.",
          reclamosATiempo:
            "Quantidade de reclamações que a IA detectou e deixou marcadas no mesmo dia, a tempo de a equipe agir.",
          iaVsHumano:
            "Mensagens respondidas pela IA frente às respondidas por uma pessoa, no período.",
          tasaRespuesta:
            "Das conversas que a IA iniciou, qual porcentagem o cliente respondeu. É respostas dividido por conversas enviadas.",
          tasaAccion:
            "Dos clientes que responderam, em que porcentagem a IA chegou a uma conclusão —satisfeito ou reclamação—. É medida sobre os que responderam.",
          satisfechos:
            "Clientes que ficaram satisfeitos. A primeira porcentagem é sobre todas as conversas enviadas; a segunda, apenas sobre as que responderam.",
          reclamos:
            "Clientes que manifestaram uma reclamação ou insatisfação. A primeira porcentagem é sobre o total enviado; a segunda, apenas sobre os que responderam.",
          sinRespuesta:
            "Clientes que não responderam à pesquisa. A primeira porcentagem é sobre o total enviado; a segunda, sobre os que responderam.",
          embudo:
            "Percurso das conversas: quantas foram enviadas, quantas responderam e quantas chegaram a uma conclusão.",
          primeraRespuesta:
            "Tempo médio que o cliente levou para responder à primeira mensagem da IA.",
          atencionHumana:
            "Indica se uma pessoa da equipe interveio no chat dentro do horário de atendimento.",
          objetoReclamo:
            "Tema principal de cada reclamação, identificado pela IA ao encerrar a conversa.",
          etiquetas:
            "Etiquetas de interesse —por exemplo, interesse em comprar— que a IA marcou nas conversas.",
          breakdowns:
            "Os mesmos resultados separados por filial e por tipo de pesquisa, para comparar.",
          canalVenta:
            "Canal de venda: P = Convencional, PA = Plano de poupança. O dado está disponível nas vendas a partir de 24/06/2026.",
        },
        heroTitle: "Estatísticas por assistente IA",
        detailTitle: "Detalhe do assistente",
        backToHero: "Voltar ao resumo",
        disabled: "O módulo de estatísticas não está habilitado para sua empresa.",
        modeTV: "Modo TV",
        exitTV: "Sair",
        clientSummary: "Resumo do cliente",
        selectAssistant: "Ver assistente",
        breakdowns: {
          title: "Detalhe por segmento",
          bySucursal: "Por filial",
          byTipoEncuesta: "Por tipo de pesquisa",
          bySubtipo: "Por subtipo",
        },
        canalVenta: {
          title: "Canal de venda",
          filterLabel: "Canal de venda",
          all: "Todos",
          convencional: "Convencional",
          planAhorro: "Plano de poupança",
          sinDato: "Sem dado",
          availabilityNote:
            "Dado disponível desde 24/06/2026 · vendas anteriores não registradas.",
          tooltip:
            "Canal de venda: P = Convencional, PA = Plano de poupança. Disponível nas vendas desde 24/06/2026.",
        },
        cards: {
          horasAhorradas: "Horas economizadas",
          horasAhorradasCaption: "{{name}} economizou {{n}} horas para você",
          cobertura: "Cobertura 24/7",
          coberturaCaption: "{{pct}} atendido fora do horário, 0 esperando um humano",
          reclamos: "Reclamações a tempo",
          reclamosCaption: "{{n}} reclamações detectadas a tempo",
          iaVsHumano: "IA vs humano",
          iaVsHumanoCaption: "{{ia}} IA / {{hum}} humano",
        },
        table: {
          asistente: "Assistente",
          tipo: "Tipo",
          enviados: "Enviados",
          respondieron: "Responderam",
          tasaResp: "Taxa resp.",
          reclamos: "Reclamações",
        },
        filters: {
          dateRange: "Intervalo de datas",
          from: "De",
          to: "Até",
          sucursal: "Filial",
          tipoEncuesta: "Tipo de pesquisa",
          all: "Todas",
          service: "Service",
          venta: "Venda",
        },
        funnel: {
          title: "Funil",
          enviados: "Enviados",
          respondieron: "Responderam",
          clasificados: "Classificados",
        },
        kpis: {
          title: "Indicadores",
          satisfechos: "Satisfeitos",
          reclamos: "Reclamações",
          sinRespuesta: "Sem resposta",
          sobreTotal: "do total",
          sobreRespondieron: "de quem respondeu",
          tasaRespuesta: "Taxa de resposta",
          tasaAccion: "Taxa de ação da Sofía",
          objetoReclamo: "Objeto da reclamação",
          tagsTrackeados: "Etiquetas monitoradas",
          interesadoComprar: "Interessado em comprar",
          primeraRespuesta: "1ª resposta do cliente",
          atencionHumana: "Atenção humana no horário",
          atendidoHorario: "Atendido no horário",
          atendidoCierre: "Atendido no fim do dia",
          si: "Sim",
          no: "Não",
        },
        insights: {
          title: "Recomendações",
          recommendations: "{{count}} recomendação",
          recommendations_plural: "{{count}} recomendações",
          severityWarning: "Aviso",
          severityInfo: "Info",
          severitySuccess: "Conquista",
          severityOportunidad: "Oportunidade",
          severitySofiaEnAccion: "Sofía em ação",
          ventana_muerta:
            "Sofía atende a qualquer hora. {{count}} pesquisas saíram após as {{horaLimiteDisparo}}h; como o aviso à equipe só dispara {{timeoutHours}}h depois, os poucos que não respondem não chegam a passar para uma pessoa antes do fechamento. Disparando-as mais cedo se recupera essa margem.",
          disparo_tardio:
            "Sofía dispara as pesquisas por volta das {{medianaHoraDisparo}}h. Antecipando o envio, mais clientes que não respondem chegam a passar para a equipe antes do fechamento.",
          timeout_absorbe:
            "{{pct}} não respondeu dentro da janela. Sofía ficou disponível mesmo assim para quando quiserem retomar.",
          reclamo_sin_atencion:
            "Sofía detectou e marcou {{count}} reclamações no mesmo dia. Para fechar o ciclo, convém que uma pessoa as assuma antes do fechamento.",
          buena_cobertura:
            "Sofía respondeu {{fueraHorarioCount}} pesquisas fora do horário — atendimento que um humano não teria dado.",
          generic: "Recomendação disponível.",
        },
        units: {
          horas: "h",
          seg: "s",
          min: "min",
        },
        empty: {
          noData: "Ainda não há dados para este período.",
          noAssistants: "Este cliente ainda não tem assistentes com estatísticas.",
          noObjeto: "Sem objetos de reclamação neste período.",
          noTags: "Sem etiquetas monitoradas neste período.",
          noPeriod: "Sem dados neste período.",
        },
      },
      chatInput: {
        systemChannelReadOnly: "Canal de avisos automáticos. Não é possível enviar mensagens.",
      },
      matchpropBanner: {
        text: "Você tem {{count}} correspondência(s) de imóveis sem revisar no MatchProp",
        goToChat: "Ir para o chat de Alertas de Imóveis",
      },
      chatHighlight: {
        needsAttention: "Precisa de atenção",
        matchprop: "Correspondência de imóvel",
      },
      matchpropCard: {
        title: "Correspondência detectada",
        test: "TESTE",
        levelExact: "EXATO",
        levelSimilar: "PARECIDO",
        requestLabel: "Pedido",
        inGroup: "no grupo {{group}}",
        operacion: "Operação",
        tipo: "Tipo",
        dorms: "Dorm.",
        zonas: "Zonas",
        precioMax: "Preço máx.",
        matchesHeader: "Correspondências",
        priceOnRequest: "preço a consultar",
        viewListing: "Ver ficha",
        contactAuthor: "Escrever para {{name}}",
        contactAuthorShort: "Escrever ao colega",
        viewInGroup: "Ver pedido no grupo",
        contactOk: "Chat do colega aberto",
        groupNotFound: "Chat do grupo não encontrado",
        actionError: "Não foi possível concluir a ação",
      },
      turnosIA: {
        setupHealth: {
          titulo: "Esta empresa não terminou a ativação do TurnosIA",
          token: {
            queFalta: "A empresa não tem o token do WAIA configurado.",
            comoResolver: "Ele é copiado sozinho ao ativar o módulo TurnosIA pelo WAIA: desligue e ligue esse botão de novo.",
          },
          rubro: {
            queFalta: "A empresa não tem um ramo aplicado.",
            comoResolver: "No painel superadmin do TurnosIA, escolha o modelo de ramo: ele cria especialidades, campos e o vocabulário do negócio.",
          },
          especialidades: {
            queFalta: "Não há nenhuma especialidade cadastrada, então não dá para criar um profissional.",
            comoResolver: "Aplique um modelo de ramo (ele as cria) ou cadastre-as à mão em Serviços.",
          },
        },
        bandeja: {
          tituloTarjeta: "Casos para resolver",
          tituloInbox: "Caixa de casos",
          sinCasos: "Não há casos pendentes. A IA está resolvendo tudo sozinha. 🎉",
          sinNombre: "Sem nome",
          enCurso: "Em andamento",
          tomar: "Assumir",
          resuelto: "Resolvido",
          resolverTurno: "Agendar",
          asignarTurno: "Atribuir {{appointment}}",
          verTurno: "Ver {{appointment}}",
          notasTurno: "Notas {{delAppointment}}",
          abrirChat: "Abrir chat",
          sinTelefonoValido: "Sem telefone válido",
          chatNoEncontrado: "Nenhum chat aberto encontrado para este contato.",
          tomadoOk: "Caso assumido",
          resueltoOk: "Caso resolvido",
          errorGuardar: "Não foi possível atualizar o caso",
          turnoCreadoHint: "Pronto, foi agendado. Se o caso foi resolvido, marque como Resolvido.",
          turnoRelacionado: "{{appointment_c}} relacionado",
          motivo: "Motivo",
          horaCaso: "Hora",
          transcriptNoDisponible: "O detalhe da conversa não está disponível nesta visão.",
          conversacion: "Conversa",
          reason: {
            fuera_de_alcance: "Fora do escopo",
            pidio_humano: "Pediu um humano",
            sin_disponibilidad: "Sem disponibilidade",
            reclamo: "Reclamação",
            urgente: "Urgente",
            fallo_tecnico: "Falha técnica",
            otro: "Outro",
          },
        },
        vocabDefaults: {
          patient: "paciente", patientPlural: "pacientes",
          patientName: "Nome do paciente", patientPhone: "Telefone",
          professional: "profissional", professionalPlural: "profissionais",
          appointment: "agendamento", appointmentPlural: "agendamentos",
          specialty: "especialidade", specialtyPlural: "especialidades",
          service: "serviço", servicePlural: "serviços",
          waitingRoom: "sala de espera", waitingRoomPlural: "salas de espera",
          cobertura: "convênio", coberturaPlural: "convênios",
          scheduler: "agendador", schedulerPlural: "agendadores",
          room: "consultório", roomPlural: "consultórios",
          patientGen: "m", professionalGen: "m", appointmentGen: "m", specialtyGen: "f",
          serviceGen: "m", waitingRoomGen: "f", coberturaGen: "m", schedulerGen: "m", roomGen: "m",
        },
        metricas: {
          widget: {
            verMas: "Ver mais",
            verMasTooltip: "Ver a página completa de métricas",
            tooltip: "O que o assistente fez pelo seu negócio",
            vacio: "Aqui você verá o que o assistente faz por você: {{appointmentPlural}} que agenda sozinho e {{appointmentPlural}} que recupera quando alguém cancela. Ainda sem atividade para mostrar.",
            mes: "No mês até agora",
            d30: "Últimos 30 dias",
            agendadosSolos: "{{appointmentPlural}} agendados sozinho",
            seAgendaronSolos: "agendados sozinho",
            de: "de",
            recuperados: "recuperados",
            previos: "30 dias anteriores: {{n}}",
          },
          filtroProfesional: "{{professional_c}}",
          filtroServicio: "{{service_c}}",
          sinFiltro: "Sem filtro",
          errorCarga: "Não foi possível carregar as métricas. Tente de novo em instantes.",
          d7: "7 dias", d30: "30 dias", d90: "90 dias", m12: "12 meses",
          aTitulo: "O que o assistente fez pelo seu negócio",
          aSub: "O retorno do assistente no período escolhido.",
          aVacio: "Aqui você verá o que o assistente faz por você: {{appointmentPlural}} que agenda sozinho, {{appointmentPlural}} que recupera quando alguém cancela, e as consultas que passa para uma pessoa. Ainda sem atividade para mostrar.",
          aAgendadosSolos: "{{appointmentPlural_c}} agendados sozinho",
          aRecuperados: "recuperados por rebalanceamento",
          aDerivados: "passados para uma pessoa",
          aCreadosTotal: "{{appointmentPlural}} no total",
          aCreadosRecuperados: "recuperados",
          aCreadosIA: "agendados pela IA",
          aCreadosMano: "inseridos à mão",
          aSerieRecuperados: "Recuperados",
          aNotaDesde: "O que o assistente agendou é contado desde {{fecha}} (quando começou a registrar sua origem). Antes dessa data não se mostra, para não confundir com zeros.",
          bTitulo: "Saúde da agenda",
          bSub: "Como se comportou o período.",
          bVacio: "Quando houver movimento no período você verá aqui quantos foram concluídos, quantos foram cancelados (e com quanta antecedência) e quantos não compareceram.",
          bCompletados: "Concluídos",
          bCancelados: "Cancelados",
          bNoShow: "Não compareceram",
          bAnticipacion: "Antecedência ao cancelar",
          bAnticipacionSub: "média · {{n}} cancelamento(s)",
          bAnticipacionVacio: "sem cancelamentos com data",
          bTasaConfirmacion: "Taxa de confirmação",
          bTasaSub: "{{r}}/{{s}} responderam · {{elPatient}}, não o painel",
          bTasaVacio: "sem lembretes de confirmação no período",
          cTitulo: "Qualidade do atendimento",
          cSub: "Pontualidade, espera e duração real. Calcula-se quando a equipe marca chegada / chamada / início / fim.",
          cVacio: "Quando a equipe usar o fluxo de atendimento (marcar que chegou, que foi chamado e quando começou e terminou) você verá aqui a pontualidade, quanto se espera e a duração real.",
          cPuntualidad: "Pontualidade (atraso médio ao iniciar)",
          cPuntualidadSub: "{{pct}}% no horário · {{n}} atendidos",
          cEspera: "Espera média",
          cEsperaSub: "{{n}} com hora de chegada",
          cEsperaVacio: "sem registro de chegada",
          cDuracion: "Duração real (média)",
          cDuracionSub: "estimado {{est}} min · {{n}} atendidos",
          cSinDatos: "ainda sem dados",
          dTitulo: "Atividade do assistente",
          dSub: "Encaminhamentos para uma pessoa e lembretes enviados.",
          dVacio: "Aqui você verá por quais motivos o assistente encaminhou consultas para uma pessoa e quantos lembretes enviou. Ainda sem atividade no período.",
          dMotivos: "Motivos de encaminhamento ({{n}})",
          dSinDerivaciones: "Sem encaminhamentos no período.",
          dRecordatorios: "Lembretes enviados ({{s}} de {{t}})",
          dSinRecordatorios: "Sem lembretes no período.",
          dDerivaciones: "Encaminhamentos",
          dEnviados: "Enviados",
          dFallidos: "Falhados",
          pie: "Período {{from}} → {{to}}. Os números vêm do sistema e são verificáveis; as métricas que hoje não podem ser calculadas com confiança não são mostradas.",
          rConfirmacionReserva: "Confirmação de reserva",
          rRecordatorio: "Lembrete",
          rPedidoConfirmacion: "Pedido de confirmação",
          rOfertaLiberado: "Oferta de vaga liberada",
          rOfertaListaEspera: "Oferta de lista de espera",
        },
        menu: {
          metricas: "Métricas",
          agenda: "Agenda",
          profesionales: "Profissionais",
          agendadores: "Secretárias",
          servicios: "Serviços",
          disponibilidad: "Disponibilidade",
          precios: "Preços",
          listaEspera: "Lista de Espera",
          recordatorios: "Lembretes",
          ajustes: "Configurações",
          miAgenda: "Minha Agenda",
        },
        calendar: {
          title: "Calendário",
          day: "Dia",
          week: "Semana",
          month: "Mês",
          today: "Hoje",
          prev: "Anterior",
          next: "Próximo",
          noEvents: "Não há {{appointmentPlural}} neste período.",
          colorByProfessional: "Cor por {{professional}}",
          colorByStatus: "Cor por estado",
          allProfessionals: "Sem filtro",
          allAssigned: "Sem filtro (apenas atribuídos)",
          outOfHours: "Fora do horário disponível",
          movePast: "Não é possível mover nada para o passado",
          moveConfirmTitle: "Reagendar",
          moveConfirmText: "Mover {{name}} de {{oldDateTime}} para {{newDateTime}}? Avisamos via WhatsApp.",
          moveCancelar: "Cancelar",
          moveConfirmar: "Confirmar",
          moveSuccess: "Pronto, foi reagendado",
          moveErrorGeneric: "Não foi possível mover",
          moveOccupied: "Esse horário já está ocupado",
          moveNoPermission: "Você não tem permissão para mover {{appointmentPlural}}",
          moveDiscarded: "Não deu para soltar aí. Tente de novo, soltando no dia e horário que você quer.",
          refresh: "Atualizar",
        },
        tabs: {
          agendaDesc: "O dia de hoje, organizado por quem atende. Você pode chamar o próximo e enviar um lembrete.",
          profesionalesDesc: "Gerencie quem recebe {{appointmentPlural}}. Você pode adicionar, editar ou desativar.",
          agendadoresDesc: "Quem agenda {{appointmentPlural}} à mão e pode habilitar encaixes. Você pode adicionar, editar ou desativar.",
          serviciosDesc: "Configure o que se oferece, quanto dura e quem atende.",
          disponibilidadDesc: "Configure horários de atendimento e bloqueios de agenda, um por um.",
          preciosDesc: "A lista de preços da empresa. Carrega-se de um arquivo e pode corrigir-se à mão.",
          listaEsperaDesc: "Quem espera por uma vaga, e o histórico de rebalanceamentos automáticos.",
          recordatoriosDesc: "Histórico de mensagens enviadas e agendadas.",
          ajustesDesc: "Configuração de integração, lembretes e modelos de mensagens.",
        },
        status: {
          available: "Disponível",
          reserved: "Reservado",
          completed: "Concluído",
          cancelled: "Cancelado",
          pending: "Pendente",
          confirmed: "Confirmado",
          in_progress: "Em atendimento",
          arrived: "Na sala",
          called: "Chamado",
          no_show: "Não compareceu",
        },
        panel: {
          servicio: "Serviço",
          profesional: "Profissional",
          fechaHora: "Data e hora",
          consultorio: "Consultório",
          telefono: "Telefone",
          sobreturno: "Encaixe",
          cambiarEstado: "Alterar estado",
          estadoActualizado: "Estado atualizado",
          estadoError: "Não foi possível alterar o estado",
          notas: "Notas",
          acciones: "Ações",
          historial: "Histórico",
          proximamente: "Em breve",
          cerrar: "Fechar",
          notasVacio: "Ainda sem notas",
          notaPlaceholder: "Adicionar uma nota...",
          notaAgregar: "Adicionar",
          notaCreada: "Nota adicionada",
          notaError: "Não foi possível adicionar a nota",
          cancelarConMotivo: "Cancelar com motivo",
          cancelarMotivoLabel: "Motivo",
          cancelarTitulo: "Cancelar",
          cancelarOk: "Cancelado, avisamos pelo WhatsApp",
          cancelarError: "Não foi possível cancelar",
          eliminar: "Excluir",
          eliminarTitulo: "Excluir",
          eliminarTexto: "Sai da agenda, mas permanece no histórico.",
          eliminarMotivoLabel: "Motivo (opcional)",
          eliminarOk: "Excluído",
          eliminarError: "Não foi possível excluir",
          reAvisarBtn: "Reavisar",
          reAvisarOk: "Aviso enviado",
          reAvisarError: "Não foi possível reenviar o aviso",
          llamarBtn: "Chamar",
          llamarOk: "Passou para em atendimento",
          llamarError: "Não foi possível chamar",
          abrirChatBtn: "Abrir conversa",
          sinConversacion: "Sem conversa",
          sinTelefonoValido: "Sem telefone válido",
          dialogCancelar: "Cancelar",
          dialogConfirmar: "Confirmar",
          reprogramar: "Reagendar",
          reprogramarTitulo: "Reagendar",
          reprogramarFecha: "Nova data",
          reprogramarHorario: "Horário disponível",
          reprogramarSinSlots: "Não há horários disponíveis nesse dia",
          reprogramarConfirmar: "Reagendar",
          reprogramarAviso: "Avisamos pelo WhatsApp.",
          reprogramarOk: "Reagendado, avisamos pelo WhatsApp",
          reprogramarError: "Não foi possível reagendar",
          score: {
            cancelo: "Cancelou",
            ausente: "Não compareceu",
            clienteRiesgo: "{{patient_c}} de risco",
          },
        },
        aiBooked: "Agendado pelo assistente IA",
        manualBooked: "Cadastrado manualmente",
        recoveredBooked: "♻ Recuperado pelo rebalanceamento",
        overtime: {
          configurar: "Configurar encaixe",
          finDelDia: "Encaixe no fim do dia",
          entreTurnos: "Encaixe intercalado",
          maxSobreturnos: "Máx. encaixes do dia",
          guardar: "Salvar",
          guardado: "Configuração salva",
          cancelar: "Cancelar",
          yaHayTurno: "Já há algo com {{name}} nesse horário",
          badge: "Encaixe",
          cargarSobreturno: "Adicionar encaixe",
          activarHint: "Ative o encaixe de hoje para poder adicionar um",
          sinDisponibles: "Não há encaixes disponíveis",
        },
        atencion: {
          llego: "Chegou",
          llegoTooltip: "Marcar que o cliente já está aqui. Evita a mensagem «você está chegando?»",
          llegoOk: "{{nombre}}: chegada registrada",
          llegoError: "Não foi possível registrar a chegada",
          llamar: "Chamar",
          llamarError: "Não foi possível chamar",
          comenzarAtencion: "Iniciar atendimento",
          comenzarError: "Não foi possível iniciar o atendimento",
          rellamar: "Chamar novamente",
          rellamarOk: "Aviso reenviado",
          rellamarError: "Não foi possível reenviar o aviso",
          cancelarAusente: "Cancelar (ausente)",
          confirmarAusenteTitulo: "Marcar como ausente?",
          confirmarAusenteTexto: "A vaga é liberada e fica registrado como ausente.",
          ausenteOk: "Marcado como ausente",
          ausenteError: "Não foi possível marcar como ausente",
          enAtencion: "Em atendimento",
          terminarAtencion: "Terminar atendimento",
          terminarError: "Não foi possível terminar o atendimento",
          horaObjetivo: "Horário previsto de encerramento",
          enMin: "em ~{{min}} min",
          etaTooltip: "Horário estimado de atendimento (recalculado)",
          avisoSonoroOn: "Aviso sonoro ativado",
          avisoSonoroOff: "Aviso sonoro desativado",
          nudgeSobreturno: "Você está adiantado — carregar um encaixe?",
          ahora: "Agora",
          diaEnHora: "No horário",
          diaAtrasado: "Atrasado +{{min}}min",
          diaAdelantado: "Adiantado −{{min}}min",
          sugerido: "Sugerido",
          fichaTitulo: "Chamado",
          fichaServicio: "Serviço",
          fichaTelefono: "Telefone",
          minAbrev: "min",
        },
        header: {
          servicioActivo: "Serviço ativo",
          servicioNoDisponible: "Serviço indisponível",
          title: "TurnosIA — {{appointmentPlural_c}}",
          noAcceso: "Você não tem acesso a este módulo.",
          contactarAdmin: "Entre em contato com o administrador para habilitá-lo.",
          volver: "Voltar",
          backendNoResponde: "O backend do TurnosIA não está respondendo.",
        },
        agendaHoy: "Agenda de hoje",
        turnosHoy: "Consultas de hoje",
        proximosTurnos: "A seguir",
        sobretornosHoy: "Encaixes habilitados",
        sinTurnosHoy: "Nada para hoje",
        sinTurnosProximos: "Não há consultas agendadas nos próximos dias.",
        sinTurnosPropios: "Você não tem nada agendado em breve.",
        noTurnosHoy: "Você não tem nada para hoje.",
        vasAdelantado: "Você está adiantado na agenda. Pode habilitar um encaixe para hoje.",
        profesionalAdelantado: "Está adiantado na agenda. Você pode habilitar um encaixe para hoje.",
        misBloques: "Meus Blocos Especiais",
        sinSlots14Dias: "Sem slots nos próximos 14 dias.",
        slotsEspecialesHoy: "Slots especiais de hoje",
        libresCount: "{{count}} disponíveis",
        reservadosCount: "{{count}} reservados",
        adelantado: "adiantado",
        atrasado: "atrasado",
        ignorar: "Ignorar",
        tabAgenda: "Agenda",
        tabMisBloques: "Meus Blocos",
        profesional: "Profissional",
        alertasTurnosEspeciales: "{{count}} alerta{{plural}} de blocos especiais",
        importTurnos: {
          boton: "Carregar Excel",
          historialBoton: "Cargas por Excel",
          titulo: "Carga de {{appointmentPlural}} por Excel",
          tabCargar: "Carregar arquivo",
          tabHistorial: "Histórico",
          intro: "Envie a lista do sistema anterior. Primeiro você verá o que muda; nada é salvo até você confirmar.",
          elegirArchivo: "Escolha o arquivo (.xls ou .xlsx)",
          verConfig: "Configuração da carga",
          ocultarConfig: "Ocultar configuração",
          servicioDefault: "Serviço usado na carga",
          servicioDefaultAyuda: "O arquivo não traz o serviço: todos são carregados com este.",
          sinServicio: "Não configurado",
          recordatoriosDefault: "As novas cargas recebem lembretes programados",
          configGuardada: "Configuração salva",
          errorConfig: "Não foi possível salvar a configuração",
          errorLeer: "Não foi possível ler o arquivo",
          errorImportar: "Não foi possível concluir a carga",
          errorRevertir: "Não foi possível reverter a carga",
          noSePuedeImportar: "O arquivo tem problemas e não pode ser carregado:",
          radio: "Serão criados {{crear}} e cancelados {{cancelar}}. Nenhuma mensagem é enviada agora.",
          radioRecordatorios: "Serão programados {{n}} lembretes.",
          radioSinRecordatorios: "Estes {{appointmentPlural}} não vão receber lembretes.",
          radioInmediatos: "{{n}} desses lembretes saem nos próximos minutos: o horário de envio já chegou.",
          rangoDeclarado: "Período do arquivo: de {{desde}} a {{hasta}} (declarado na linha {{fila}}).",
          rangoDerivado: "Período do arquivo: de {{desde}} a {{hasta}} (calculado pelas linhas: o arquivo não o declara).",
          sinRango: "Não foi possível determinar o período do arquivo.",
          rangoEfectivo: "A comparação começa em {{desde}}: nada anterior é criado nem cancelado.",
          servicioUsado: "Serviço: {{nombre}}",
          chipLeidas: "{{n}} linhas lidas",
          chipCrear: "{{n}} a criar",
          chipExistentes: "{{n}} já existem",
          chipPasadas: "{{n}} passadas (ignoradas)",
          chipCancelar: "{{n}} a cancelar",
          chipIncidencias: "{{n}} ocorrências",
          checksumOk: "Controle de linhas: {{leidas}} de {{declaradas}}",
          checksumMal: "O controle de linhas NÃO confere: {{leidas}} lidas, {{declaradas}} declaradas",
          telefonos: "Telefones: {{moviles}} com 15, {{asumidos}} considerados celular, {{invalidos}} inválidos",
          switchRecordatorios: "Enviar lembretes programados a estes {{appointmentPlural}}",
          switchRecordatoriosAyuda: "A confirmação de reserva não é enviada: o cliente já combinou com o consultor.",
          asesoresTitulo: "Consultores do arquivo e seu {{professional}}",
          asesoresSinAsociar: "{{n}} sem vínculo: as linhas deles não são carregadas",
          sinAsociar: "Sem vínculo",
          guardarAsesores: "Salvar vínculos",
          cancelarTitulo: "Serão cancelados {{n}} {{appointmentPlural}}",
          cancelarAyuda: "Foram carregados de um arquivo anterior e não aparecem neste. Nunca se cancela o que o assistente agendou ou o que foi lançado à mão.",
          colCliente: "Cliente",
          colSucursal: "{{professional_c}}",
          colFecha: "Data",
          colHora: "Hora",
          incidenciasTitulo: "{{n}} linhas com ocorrências (não são carregadas)",
          protegidosTitulo: "{{n}} {{appointmentPlural}} não são cancelados porque a linha deles tem uma ocorrência",
          protegido: "{{cliente}} — {{fecha}} {{hora}}",
          fila: "Linha {{n}}",
          archivo: "Arquivo",
          importado: "Carga #{{lote}}: {{creados}} criados, {{cancelados}} cancelados",
          importadoConIncidencias: "{{n}} linhas não foram carregadas: veja as ocorrências no histórico",
          revertido: "Carga #{{lote}} revertida: {{borrados}} apagados, {{restaurados}} restaurados",
          revertResultado: "Carga #{{lote}} revertida: {{borrados}} apagados e {{restaurados}} restaurados.",
          revertPasosSaltados: "{{n}} lembretes que venceram enquanto o agendamento estava cancelado não serão enviados.",
          noRevertiblesTitulo: "{{n}} não foram revertidos (tiveram mudanças depois da carga):",
          historialVacio: "Ainda não há cargas.",
          colCargado: "Carregado",
          colArchivo: "Arquivo",
          colRango: "Período",
          colCreados: "Criados",
          colCancelados: "Cancelados",
          colExistentes: "Já existiam",
          colIncidencias: "Ocorrências",
          colEstado: "Status",
          estadoRevertido: "Revertida",
          estadoAplicado: "Aplicada",
          sinRecordatorios: "sem lembretes",
          revertir: "Reverter",
          historialAyuda: "Só é possível reverter a última carga aplicada.",
          cerrar: "Fechar",
          confirmar: "Confirmar: criar {{crear}} e cancelar {{cancelar}}",
          revertirTitulo: "Reverter a carga #{{lote}}",
          revertirTexto: "Os {{creados}} {{appointmentPlural}} criados são apagados (exceto os que já mudaram) e os {{cancelados}} cancelados são restaurados. Nenhuma mensagem é enviada."
        },
      },
      agenda: {
        cargarAMano: "Adicionar à mão",
        asignarA: "Atribuir a",
        sinRecurrencia: "Sem recorrência",
        sinAcceso: "Sem acesso",
        accesoPermanente: "Acesso permanente",
        accesoPorCaso: "Caso a caso (requer aprovação)",
        placeholderBloque: "ex: controle, revisão, urgência",
        alertasTitulo: "Alertas de blocos especiais cancelados",
        sinAlertas: "Não há alertas pendentes.",
        sinAsignados: "Você ainda não tem nada atribuído.",
        color: "Cor:",
        slot: "Espaço:",
        nombrePaciente: "Nome do paciente *",
        telefono: "Telefone *",
        email: "Email (opcional)",
        profesional: "Profissional",
        profesionalReq: "Profissional *",
        servicio: "Serviço *",
        helperTelefono: "Com código do país, ex: 5511912345678",
        nombreBloque: "Nome do bloco *",
        inicio: "Início *",
        fin: "Fim *",
        duracionSlot: "Duração por slot (minutos)",
        recurrencia: "Recorrência",
        accesoAgendador: "Acesso {{delScheduler}}",
        fecha: "Data *",
        sinSlots: "Sem slots disponíveis para essa data",
        seleccionarProfFechaSvc: "Selecione {{professional}}, data e {{service}}",
        guardarTurno: "Salvar",
        asignar: "Atribuir",
        crearBloque: "Criar bloco",
        habilitarSobreturno: "Habilitar encaixe",
        habilitarSobreturnos: "Habilitar encaixes",
        solicitarAcceso: "Solicitar acesso",
        actualizar: "Atualizar",
        llamarSiguiente: "Chamar próximo",
        llamar: "Chamar",
        enviarRecordatorio: "Enviar lembrete",
        agendadorSinAcceso: "{{scheduler_c}} sem acesso",
        agendadorConAcceso: "{{scheduler_c}} com acesso",
        desactivarBloque: "Desativar bloco",
        especial: "Especial",
        libre: "Disponível",
        reservado: "Reservado",
        pacienteNotificado: "Avisamos pelo WhatsApp",
        turnoActualizadoSinWA: "Atualizado, mas o WhatsApp não estava disponível",
        errorLlamarSiguiente: "Erro ao chamar próximo",
        recordatorioEnviado: "Lembrete enviado",
        errorRecordatorio: "Erro ao enviar lembrete",
        sobreturnuHabilitado: "Encaixe habilitado para hoje",
        errorSobreturno: "Não foi possível habilitar o encaixe",
        sobretornosHabilitados: "Encaixes habilitados para hoje",
        sobretornosDeshabilitados: "Encaixes desabilitados",
        errorSobreturnos: "Erro ao atualizar encaixes",
        bloqueCreado: "Bloco especial criado",
        errorBloque: "Erro ao criar o bloco",
        pacienteAsignado: "Atribuído ao bloco especial",
        errorAsignar: "Não foi possível atribuir",
        errorAsignarSimple: "Erro ao atribuir",
        solicitudEnviada: "Solicitação enviada",
        errorSolicitud: "Erro ao enviar a solicitação",
        errorAcceso: "Não foi possível atualizar o acesso",
        bloqueDesactivado: "Bloco desativado",
        errorDesactivar: "Erro ao desativar o bloco",
        errorCargarDatos: "Erro ao carregar dados",
        camposObligatorios: "Preencha todos os campos obrigatórios (*)",
        campoRequerido: "O campo \"{{label}}\" é obrigatório",
        eligeHorario: "Escolha um horário",
        turnoCargado: "Pronto, foi agendado",
        errorCargarTurno: "Não foi possível agendar",
        usuarioSinProfesional: "Seu usuário não está vinculado. Entre em contato com o administrador.",
        errorProfesionales: "Não foi possível carregar a lista.",
      },
      profesionales: {
        titulo: "Profissionais",
        agregarBtn: "Adicionar",
        headerNombre: "Nome",
        headerEspecialidad: "Especialidade",
        headerCapacidad: "Simultâneos",
        headerCupoDiario: "Limite por dia",
        headerEstado: "Status",
        headerAcciones: "Ações",
        sinProfesionales: "Você ainda não cadastrou {{professionalPlural}}.",
        sinEspecialidad: "Sem {{specialty}}",
        cancelar: "Cancelar",
        nuevo: "Adicionar {{professional}}",
        editar: "Editar {{professional}}",
        activo: "Ativo",
        inactivo: "Inativo",
        activar: "Ativar",
        desactivar: "Desativar",
        nombre: "Nome *",
        especialidad: "Especialidade",
        emailReq: "Email *",
        email: "Email",
        passwordReq: "Senha *",
        nuevaPassword: "Nova senha",
        helperPassword: "Deixe em branco para não alterar",
        consultorio: "Consultório",
        capacidad: "Atendimento simultâneo",
        capacidadUnidad: "agendamentos",
        capacidadAyuda: "Quantos {{appointmentPlural}} pode atender ao mesmo tempo (1 = um por vez)",
        cupoDiario: "Limite de agendamentos por dia",
        cupoDiarioAyuda: "Opcional. Vazio = sem limite. Limita o que o assistente agenda; pelo painel dá para carregar mesmo assim.",
        diasAFuturo: "Dias à frente para agendar",
        diasAFuturoAyuda: "Opcional. Vazio = o da empresa. Até quantos dias à frente dá para agendar neste recurso (nunca mais que o da empresa).",
        anticipacionMinima: "Antecedência mínima para agendamentos (dias)",
        anticipacionMinimaAyuda: "Opcional. Vazio = o da empresa. Com quantos dias de antecedência mínima o assistente IA pode oferecer e agendar neste recurso (nunca menos que o da empresa). Os dias mais próximos são agendados pelos atendentes no painel.",
        consultorioPlaceholder: "ex: 1, 3, A",
        queueWarning: "O utilizador foi criado mas não foi possível atribuir uma fila. Atribua-a manualmente no WAIA.",
        guardar: "Salvar",
        errorNombre: "O nome é obrigatório",
        errorCredenciales: "Email e senha são obrigatórios",
        errorGuardar: "Não foi possível salvar. Confira os dados e tente de novo.",
        tooltipEditar: "Editar",
        avisoMailLabel: "E-mails de aviso {{delProfessional}}",
        avisoMailPlaceholder: "ex: recepcao@empresa.com, gerente@empresa.com",
        avisoMailAyuda: "Opcional. Recebe só {{losAppointmentPlural}} {{delProfessional}} feitos pelo assistente IA. Separe vários com vírgulas (até 10). Não é o e-mail de acesso ao sistema.",
        avisoMailInvalidas: "Estes endereços não são válidos: {{list}}",
        avisoMailDemasiadas: "É possível cadastrar até {{max}} endereços.",
        emailIngresoAyuda: "É o usuário para entrar no sistema. Não recebe avisos.",
        headerAvisoMail: "Aviso por e-mail",
        avisoMailSin: "Sem aviso próprio",
        avisoMailCount: "{{count}} endereço(s)",
        avisoMailSwitch: "Aviso por e-mail ativo",
        avisoMailSwitchAyuda: "Desligado, os endereços abaixo não recebem avisos, mas continuam salvos. A lista da empresa continua recebendo tudo.",
        avisoMailApagado: "Desligado ({{count}} endereço(s))",
      },
      precios: {
        titulo: "Preços",
        importar: "Importar",
        historial: "Histórico",
        sinLista: "Você ainda não carregou uma lista de preços.",
        vigenteDesdeChip: "Vigente desde {{fecha}}",
        importadaEl: "Importada em {{fecha}}",
        listaVencida: "Esta lista tem {{dias}} dias e o limite configurado é de {{umbral}}. Atualize-a: o assistente não vai passar preços de uma lista vencida.",
        buscar: "Buscar",
        todos: "Todos",
        headerPrecio: "Preço",
        headerAcciones: "Ações",
        headerItems: "Preços",
        headerEstado: "Estado",
        noAplica: "Não se aplica",
        estadoActivo: "Com preço",
        sinResultados: "Nenhum preço corresponde ao filtro.",
        editar: "Corrigir",
        editarTitulo: "Corrigir preço",
        etiqueta: "Etiqueta",
        helperPrecio: "Deixe vazio se não tiver preço carregado.",
        helperEtiqueta: 'Para ofertas com nome, como "Revisão Gratuita". É dito no lugar do número.',
        avisoAtributos: "Para mudar a que corresponde este preço, corrija o arquivo e importe de novo.",
        rangoFiltroPlaceholder: "Digite um valor",
        borrarLista: "Excluir",
        estado_active: "Em uso",
        estado_archived: "Arquivada",
        estado_draft: "Rascunho",
        importarTitulo: "Importar lista de preços",
        formato: "Tipo de planilha",
        formato_matrix_km: "Uma linha por veículo e uma coluna por quilometragem",
        formato_long_csv: "CSV: um preço por linha",
        formatoHelp_matrix_km: "O mural de sempre: cada linha é um modelo, cada coluna uma revisão (10.000, 20.000…) e os adicionais no final.",
        formatoHelp_long_csv: "Uma linha por preço. As colunas que não sejam preço, estado, etiqueta ou nota são tomadas como dados do preço.",
        formato_ejes_declarados: "Com aba de configuração (CONFIG)",
        formatoHelp_ejes_declarados: "A planilha nova: além dos preços tem uma aba CONFIG que diz o que é cada coluna (modelo, versão, anos, quilometragem).",
        rechazan: "{{count}} problema impede a importação",
        cobertura: "Cobertura por sujeito",
        sinPreciosPara: "sem preços para {{v}}",
        dejarEnBorrador: "Deixar como rascunho (ainda não substitui a lista vigente)",
        avisoBorrador: "A lista é carregada mas NÃO entra em uso: você pode revisá-la e ativá-la depois. O assistente continua respondendo com a lista vigente.",
        elegirArchivo: "Toque aqui para escolher o arquivo (.xlsx ou .csv)",
        resumen: "O que o arquivo traz",
        ejes: "Agrupa-se por",
        chipTotal: "{{n}} preços",
        chipActivos: "{{n}} com preço",
        chipNoAplica: "{{n}} não se aplica",
        chipOmitidas: "{{n}} não serão carregados",
        diffPrimera: "É a primeira lista: tudo é novo.",
        diffContra: 'Comparado com "{{lista}}"',
        diffNuevos: "{{n}} novos",
        diffSubieron: "{{n}} subiram",
        diffBajaron: "{{n}} baixaram",
        diffIguales: "{{n}} sem mudanças",
        diffCambiosEstado: "{{n}} mudam de estado",
        diffDesaparecidos: "{{n}} desaparecem",
        diffItem: "Item",
        diffAntes: "Antes",
        diffDespues: "Agora",
        diffCambio: "Mudança",
        diffKind_nuevo: "Novo",
        diffKind_subio: "Subiu",
        diffKind_bajo: "Baixou",
        diffKind_igual: "Sem mudanças",
        diffKind_cambio_estado: "Muda de estado",
        diffKind_desaparecido: "Desaparece",
        noSeCargan: "{{count}} célula não será carregada",
        avisos: "{{count}} aviso",
        nombreLista: "Nome da lista",
        vigenteDesde: "Vigente desde",
        vigenciaDelArchivo: "Pegamos do arquivo. Mude se não estiver correta.",
        vigenciaFaltante: "O arquivo não a traz: indique a partir de quando vale.",
        incluyeIva: "Os preços incluem impostos (IVA)?",
        ivaSi: "Sim, incluem",
        ivaNo: "Não, não incluem",
        ivaNoSe: "Não se sabe",
        avisoReemplazo: "Ao confirmar, esta lista passa a ser a vigente e a anterior fica arquivada.",
        errorLeer: "Não foi possível ler o arquivo.",
        errorImportar: "Não foi possível importar o arquivo.",
        validezTitulo: "Vencimento da lista de preços",
        validezLabel: "Avisar quando a lista tiver mais de (dias)",
        validezHelper: "Vazio = sem controle de vencimento. Com um número, a lista é marcada como vencida após esses dias e o assistente para de passar preços dela.",
        formatoDetectado: "Tipo de planilha (reconhecido automaticamente)",
        formatoDetectadoHelp: "Escolhemos olhando o arquivo. Mude só se não estiver certo: o arquivo é lido de novo.",
        importarAyuda: "É a lista de preços que o assistente usa para responder consultas. Envie o Excel que a empresa mantém: antes de salvar qualquer coisa mostramos o que ele traz, o que muda em relação à lista atual e o que precisa ser corrigido.",
        archivoElegido: "{{nombre}} — toque para escolher outro",
        leyendoArchivo: "Lendo o arquivo…",
        rechazan_plural: "{{count}} problemas impedem a importação",
        rechazanAyuda: "Corrija-os no Excel (a célula está ao lado de cada um) e escolha o arquivo de novo.",
        noSeCargan_plural: "{{count}} células não serão carregadas",
        avisos_plural: "{{count}} avisos",
        incGenerico: "{{count}} caso",
        incGenerico_plural: "{{count}} casos",
        incVerTodas: "Ver os {{n}}",
        incVerMenos: "Ver menos",
        incMasCeldas: "e mais {{n}}",
        inc_CELDA_CON_ERROR: "{{count}} célula com erro de fórmula",
        inc_CELDA_CON_ERROR_plural: "{{count}} células com erro de fórmula",
        inc_COLUMNA_IGNORADA: "{{count}} coluna que não é uma quilometragem válida",
        inc_COLUMNA_IGNORADA_plural: "{{count}} colunas que não são uma quilometragem válida",
        inc_CONFIG_CLAVE_IGNORADA: "{{count}} dado da aba CONFIG que não é usado",
        inc_CONFIG_CLAVE_IGNORADA_plural: "{{count}} dados da aba CONFIG que não são usados",
        inc_CONFIG_IVA_ILEGIBLE: "O imposto da aba CONFIG não pôde ser lido",
        inc_CONFIG_IVA_ILEGIBLE_plural: "O imposto da aba CONFIG não pôde ser lido",
        inc_EJES_INFERIDOS: "As colunas foram reconhecidas automaticamente",
        inc_EJES_INFERIDOS_plural: "As colunas foram reconhecidas automaticamente",
        inc_ESCALA_CON_SALTO: "{{count}} salto nas quilometragens (pode faltar uma coluna)",
        inc_ESCALA_CON_SALTO_plural: "{{count}} saltos nas quilometragens (pode faltar uma coluna)",
        inc_FILA_SIN_PRECIOS: "{{count}} linha sem nenhum preço",
        inc_FILA_SIN_PRECIOS_plural: "{{count}} linhas sem nenhum preço",
        inc_ITEM_DUPLICADO: "{{count}} preço repetido",
        inc_ITEM_DUPLICADO_plural: "{{count}} preços repetidos",
        inc_MONEDA_IGNORADA: "A coluna de moeda não é usada",
        inc_MONEDA_IGNORADA_plural: "A coluna de moeda não é usada",
        inc_PRECIO_CERO_CON_ETIQUETA: "{{count}} preço 0 dito com sua observação",
        inc_PRECIO_CERO_CON_ETIQUETA_plural: "{{count}} preços 0 ditos com sua observação",
        inc_PRECIO_CERO_SIN_ETIQUETA: "{{count}} preço 0 sem observação",
        inc_PRECIO_CERO_SIN_ETIQUETA_plural: "{{count}} preços 0 sem observação",
        inc_PRECIO_COMO_TEXTO: "{{count}} preço escrito como texto",
        inc_PRECIO_COMO_TEXTO_plural: "{{count}} preços escritos como texto",
        inc_RANGO_CON_HUECO: "{{count}} lacuna entre anos",
        inc_RANGO_CON_HUECO_plural: "{{count}} lacunas entre anos",
        inc_RANGO_INVALIDO: "{{count}} faixa de anos mal escrita",
        inc_RANGO_INVALIDO_plural: "{{count}} faixas de anos mal escritas",
        inc_SEPARADOR_AMBIGUO: "{{count}} preço com separador duvidoso",
        inc_SEPARADOR_AMBIGUO_plural: "{{count}} preços com separador duvidoso",
        inc_SUJETO_INCOMPLETO: "{{count}} linha com preços mas sem modelo",
        inc_SUJETO_INCOMPLETO_plural: "{{count}} linhas com preços mas sem modelo",
        inc_SUJETO_VARIAS_PALABRAS: "{{count}} valor com palavras a mais",
        inc_SUJETO_VARIAS_PALABRAS_plural: "{{count}} valores com palavras a mais",
        inc_TEXTO_COMO_ETIQUETA: "{{count}} texto carregado como etiqueta",
        inc_TEXTO_COMO_ETIQUETA_plural: "{{count}} textos carregados como etiqueta",
        inc_RANGO_SOLAPADO: "{{count}} par de linhas com anos sobrepostos",
        inc_RANGO_SOLAPADO_plural: "{{count}} pares de linhas com anos sobrepostos",
        inc_RANGO_DOS_ABIERTOS: "{{count}} modelo com duas linhas sem \"até\"",
        inc_RANGO_DOS_ABIERTOS_plural: "{{count}} modelos com duas linhas sem \"até\"",
        ivaHelp_si: "O assistente pode dizer que os preços incluem impostos.",
        ivaHelp_no: "O assistente pode esclarecer que os preços não incluem impostos.",
        ivaHelp_nose: "O assistente não menciona impostos.",
        ivaSiCorto: "Incluem",
        ivaNoCorto: "Não incluem",
        ivaNoSeCorto: "Não se sabe",
        incluyeIvaCorto: "Impostos",
        crearPrecios: "Criar {{count}} preço",
        crearPrecios_plural: "Criar {{count}} preços",
        crearBorrador: "Criar {{count}} preço em rascunho",
        crearBorrador_plural: "Criar {{count}} preços em rascunho",
        crearSinArchivo: "Criar preços",
        creando: "Criando…",
        motivoSinArchivo: "Escolha um arquivo para começar.",
        motivoNoSeLeyo: "Não foi possível ler o arquivo: veja a mensagem acima.",
        motivoErrores: "Não dá para importar: há {{count}} problema no arquivo, marcado em vermelho.",
        motivoErrores_plural: "Não dá para importar: há {{count}} problemas no arquivo, marcados em vermelho.",
        motivoVacio: "O arquivo não tem nenhum preço para carregar.",
        motivoSinVigencia: "Falta indicar desde quando a lista vale.",
        cancelar: "Cancelar",
        guardar: "Salvar",
        cerrar: "Fechar",
        historialAyuda: "A lista «Em uso» é a que o assistente consulta. Um rascunho não a substitui até você ativá-lo.",
        borradoresTitulo: "Há {{count}} lista em rascunho não ativada",
        borradoresTitulo_plural: "Há {{count}} listas em rascunho não ativadas",
        borradoresAyuda: "O assistente continua usando «{{vigente}}». Revise o rascunho e ative-o quando estiver pronto.",
        borradoresAyudaSinVigente: "Ainda não há lista em uso: o assistente não dá preços até você ativar uma.",
        borradorDetalle: "{{n}} preços · importada em {{fecha}}",
        verPrecios: "Ver preços",
        probar: "Testar",
        activar: "Ativar",
        viendoLista: "Você está vendo «{{lista}}» ({{estado}}). Não é a lista que o assistente usa.",
        volverAVigente: "Voltar à lista em uso",
        activarTitulo: "Ativar «{{lista}}»",
        activarFrase: "A lista «{{nueva}}» passa a ser a que o assistente usa. A atual «{{actual}}» fica arquivada.",
        activarFraseSinVigente: "A lista «{{nueva}}» passa a ser a que o assistente usa.",
        activarColVigente: "Em uso agora",
        activarColNueva: "A que entra",
        activarProbarAntes: "Na dúvida? Teste antes: consulte um veículo real e compare o que cada lista responderia.",
        activarBoton: "Ativar",
        activarError: "Não foi possível ativar a lista.",
        activada: "«{{lista}}» agora é a lista que o assistente usa.",
        chipActivosCorto: "Com preço",
        incidencias: "Problemas da importação",
        incNinguna: "Nenhum",
        incNoRegistradas: "Não registrados",
        incNoRegistradasAyuda: "Esta lista foi importada antes de os problemas serem registrados. Para vê-los, escolha o mesmo arquivo de novo em Importar (a prévia não salva nada).",
        incQuedaronAfuera: "{{count}} célula ficou de fora",
        incQuedaronAfuera_plural: "{{count}} células ficaram de fora",
        borrarTitulo: "Excluir lista",
        borrarFrase: "«{{lista}}» será excluída com seus {{n}} preços. Não é possível desfazer. A lista em uso não muda.",
        borrarBoton: "Excluir",
        borrarError: "Não foi possível excluir a lista.",
        borrada: "«{{lista}}» foi excluída.",
        importadaBorrador: "«{{lista}}» ficou em rascunho. Ative-a depois de revisar.",
        importadaVigente: "A lista nova já está em uso.",
        probarTitulo: "Testar «{{lista}}»",
        probarAyuda: "Faça a mesma consulta que o assistente faria com um cliente real.",
        probarAyudaComparar: "Faça a mesma consulta que o assistente faria e compare com o que «{{vigente}}» responde hoje.",
        probarVehiculo: "Veículo",
        probarRango: "ano",
        probarUltimoService: "Última revisão (km)",
        probarKmActual: "Km atual",
        probarItemOpcional: "Adicional (opcional)",
        probarConsultar: "Consultar",
        probarError: "Não foi possível fazer a consulta.",
        probarEsta: "«{{lista}}»",
        probarEnUso: "Em uso: «{{lista}}»",
        probarModelo: "Modelo",
        probarItem: "Item",
        probarServiceQueToca: "Revisão correspondente: {{km}} km",
        probarAtrasado: "Atrasado {{km}} km",
        probarFalta: "Falta o dado: {{dato}}",
        probarRes_precio: "Dá o preço",
        probarRes_no_aplica: "Não se aplica a esse veículo",
        probarRes_modelo_ambiguo: "Pergunta qual é o modelo",
        probarRes_item_ambiguo: "Pergunta qual é o adicional",
        probarRes_anio_faltante: "Pergunta o {{eje}}",
        probarRes_anio_sin_cobertura: "Sem preço para esse {{eje}} → encaminha",
        probarRes_falta_dato: "Pergunta um dado que falta",
        probarRes_km_incoherentes: "Os km não batem (o atual é menor que o da última revisão) → confirma com o cliente",
        probarRes_sin_dato: "Não encontra preço → encaminha a um atendente",
        probarRes_fuera_de_grilla: "Quilometragem fora da lista → encaminha",
        probarRes_salteo_intervalos: "Pulou revisões → encaminha",
        probarRes_lista_vencida: "Lista vencida → encaminha sem preço",
        probarRes_sin_lista: "Sem lista → encaminha",
      },
      servicios: {
        titulo: "Serviços",
        tituloSeccion: "Serviços",
        nuevo: "Adicionar {{service}}",
        editar: "Editar {{service}}",
        activo: "Ativo",
        inactivo: "Inativo",
        activar: "Ativar",
        desactivar: "Desativar",
        cualquiera: "Qualquer",
        nombre: "Nome *",
        duracion: "Duração (minutos)",
        profesionalAsignado: "Quem atende",
        guardar: "Salvar",
        cancelar: "Cancelar",
        tooltipEditar: "Editar",
        headerNombre: "Nome",
        headerDuracion: "Duração",
        headerEntrega: "Entrega",
        headerPrecio: "Preço",
        precio: "Preço",
        helperPrecio: "Opcional. Na moeda do seu país — não precisa informá-la.",
        helperDuracion: "O quanto ocupa na agenda (o passo da grade de horários).",
        entrega: "Tempo de entrega (minutos)",
        helperEntrega: "Opcional. Quando o trabalho pronto é entregue. Não ocupa a agenda: é o que o assistente diz ao cliente.",
        descripcion: "Descrição",
        helperDescripcion: "Opcional. Mostramos {{alPatient}} e ajuda o assistente a entender de qual {{service}} se trata.",
        headerProfesional: "Profissional",
        headerEstado: "Status",
        headerAcciones: "Ações",
        agregarBtn: "Adicionar",
        sinServicios: "Você ainda não cadastrou {{servicePlural}}.",
        borrar: "Excluir definitivamente",
        borrarTitulo: "Excluir {{service}}",
        borrarTexto: "\u201C{{name}}\u201D sai da lista, para sempre. Desativar tira de circulação mas mantém no histórico; isto não.",
        borrarConfirmar: "Excluir",
        borrarCancelar: "Cancelar",
        borrarOk: "Pronto, foi excluído",
        borrarEnUso: "Não dá para excluir: tem {{count}} {{appointmentPlural}} no histórico. Só pode ser desativado.",
        borrarEnUsoOtros: "Não dá para excluir: está em uso em outras partes do sistema. Só pode ser desativado.",
        borrarError: "Não foi possível excluir",
      },
      agendadores: {
        titulo: "Secretárias",
        tituloSeccion: "Secretárias",
        descripcion: "Quem agenda {{appointmentPlural}} à mão, para {{losProfessionalPlural}} que lhe correspondam. Também pode habilitar encaixes em dias pontuais.",
        nuevo: "Adicionar {{scheduler}}",
        editar: "Editar {{scheduler}}",
        activo: "Ativa",
        inactivo: "Inativa",
        activar: "Ativar",
        desactivar: "Desativar",
        nombre: "Nome *",
        email: "Email",
        emailReq: "Email *",
        passwordReq: "Senha *",
        nuevaPassword: "Nova senha (opcional)",
        helperPassword: "Deixe em branco para não alterar",
        guardar: "Salvar",
        cancelar: "Cancelar",
        tooltipEditar: "Editar",
        errorNombre: "O nome é obrigatório",
        errorCredenciales: "Email e senha são obrigatórios",
        errorEmailOtroPerfil: "Esse email já pertence a um usuário com perfil {{perfil}} da empresa. Use outro email: a senha que você digitou não se aplica a um usuário que já existe.",
        errorGuardar: "Não foi possível salvar. Tente novamente.",
        usuarioReutilizado: "Esse usuário já existia no WAIA: entra com a senha anterior, a que você digitou não foi aplicada.",
        perfil: {
          admin: "administrador",
          user: "usuário",
          profesional: "profissional",
          agendador: "secretária",
          desconocido: "desconhecido",
        },
        headerNombre: "Nome",
        headerEmail: "Email",
        headerProfesionales: "Profissionais atribuídos",
        headerEstado: "Status",
        headerAcciones: "Ações",
        agregarBtn: "Adicionar",
        sinAgendadores: "Você ainda não cadastrou {{schedulerPlural}}.",
        sinAsignacion: "Sem atribuição",
        profesionalesLabel: "Profissionais atribuídos",
        noProfesionales: "Ainda não há {{professionalPlural}} disponíveis.",
      },
      recordatorios: {
        titulo: "Lembretes",
        tipo: "Tipo",
        estado: "Status",
        pendiente: "Pendente",
        enviado: "Enviado",
        fallido: "Falhou",
        respondido: "Respondido",
        saltado: "Pulado",
        todosLosTipos: "Todos os tipos",
        todosLosEstados: "Todos os status",
        historial: "Histórico de lembretes",
        seguimiento: "Acompanhamento dos lembretes enviados. O sistema os envia sozinho, conforme a configuração da empresa.",
        paciente: "Paciente",
        programadoPara: "Agendado para",
        vistaPrev: "Pré-visualização",
        noHayRegistros: "Nenhum lembrete registrado",
        sinDatos: "Sem dados de lembretes disponíveis",
        confirmacionReserva: "Confirmação de agendamento",
        recordatorioSimple: "Lembrete",
        solicitudConfirmacion: "Solicitação de confirmação",
        ofertaRebalanceo: "Oferta de rebalanceamento",
        ofertaListaEspera: "Oferta de lista de espera",
      },
      configuracion: {
        titulo: "Configuração de disponibilidade",
        horariosAtencion: "Horários de atendimento",
        agregarHorario: "Adicionar horário",
        dia: "Dia",
        desde: "De",
        hasta: "Até",
        acciones: "Ações",
        sinHorarios: "Sem horários configurados",
        cupoVentana: "Limite da faixa",
        cupoVentanaAyuda: "Opcional. Vazio = sem limite. Quantos agendamentos esta faixa aceita; limita o assistente, não o painel.",
        editar: "Editar",
        editarHorario: "Editar horário",
        bloqueosAgenda: "Bloqueios de agenda",
        agregarBloqueo: "Adicionar bloqueio",
        motivo: "Motivo",
        sinBloqueos: "Sem bloqueios",
        eliminar: "Excluir",
        diaSemana: "Dia da semana",
        horaInicio: "Hora de início",
        horaFin: "Hora de fim",
        fechaHoraInicio: "Data/hora de início",
        fechaHoraFin: "Data/hora de fim",
        motivoOpcional: "Motivo (opcional)",
        cancelar: "Cancelar",
        guardar: "Salvar",
      },
      listaEspera: {
        titulo: "Lista de Espera",
        descripcion: "Quem pediu uma vaga e não encontrou disponibilidade. Avisamos automaticamente se algo compatível for liberado.",
        tituloLista: "Lista de espera",
        profesional: "Profissional",
        servicio: "Serviço",
        estado: "Status",
        cualquiera: "Qualquer",
        todos: "Todos",
        tooltipEliminar: "Remover da lista",
        enEspera: "Aguardando",
        ofertaEnviada: "Oferta enviada",
        confirmado: "Confirmado",
        expirado: "Expirado",
        eliminado: "Removido",
        pendiente: "Pendente",
        enCurso: "Em andamento",
        completado: "Concluído",
        fallido: "Falhou",
        abandonado: "Abandonado",
        listaEspera: "Lista de espera",
        adelantamiento: "Adiantamento",
        eliminar: "Remover",
        cancelar: "Cancelar",
        headerPaciente: "Paciente",
        headerProfesional: "Profissional",
        headerServicio: "Serviço",
        headerPedido: "Dia/hora solicitados",
        sinPreferencia: "Sem preferência",
        headerIngreso: "Entrou",
        headerVence: "Vence",
        headerEstado: "Status",
        headerAcciones: "Ações",
        noHayPacientes: "Não há ninguém esperando.",
        enEsperaCount: "{{count}} aguardando",
        historialRebalanceos: "Histórico de rebalanceamentos",
        histHeaderId: "ID",
        histHeaderTurno: "Vaga liberada",
        histHeaderProfesional: "Profissional",
        histHeaderEstado: "Status",
        histHeaderFase: "Fase",
        histHeaderIntentos: "Tentativas",
        histHeaderIniciado: "Iniciado",
        sinHistorial: "Sem histórico de rebalanceamentos",
        eliminarDialogTitle: "Remover da lista de espera",
        confirmarEliminar: "Confirmar remoção de",
        estePaciente: "esta pessoa",
        deListaEspera: "da lista de espera? Esta ação não pode ser desfeita.",
      },
      identificadorContacto: {
        title: "Identificador do contato",
        help: "O dado que identifica o que o contato traz —a placa numa oficina, o nome do animal numa veterinária, o número de série numa assistência técnica—. Aparece ao lado do nome no chat e na ficha do contato. Se houver mais de uma chave, usa-se a primeira que tiver valor.",
        clave: "Chave da ficha",
        etiqueta: "Rótulo",
        fichas: "{{n}} fichas com o dado",
        agregar: "Adicionar chave",
        quitar: "Remover",
        guardar: "Salvar",
        guardado: "Identificador salvo",
        sinFichas: "Ainda não há fichas carregadas: as chaves aparecem quando entra a primeira campanha. Você pode digitar a chave mesmo assim.",
        vacio: "Sem identificador: nada é mostrado ao lado do nome.",
        max: "No máximo 3 chaves.",
      },
      reminderStepTemplate: {
        title: "Modelo de WhatsApp para esta etapa",
        help: "Opcional. Se você escolher um modelo aprovado, esta etapa é enviada com ele e cada variável numerada é preenchida com a variável escolhida. Sem escolha, é enviada como sempre (texto dos Modelos de mensagem e modelo conforme o dia).",
        templateLabel: "Modelo aprovado",
        automatic: "Automático (como sempre)",
        varCount: "{{count}} variável(is)",
        notApproved: "não está mais aprovado",
        noneApproved: "A linha da empresa não tem modelos aprovados.",
        unavailable: "Não foi possível carregar os modelos aprovados. Tente novamente mais tarde.",
        varPlaceholder: "ex. fecha_ddmmaaaa ou dato.patente",
        varsHelp: "Variáveis: nombre, fecha, fecha_ddmmaaaa (DD/MM/AAAA), hora, servicio, profesional, empresa… e dato.<chave> para os dados próprios do agendamento (ex. dato.patente). Se um agendamento não tiver o dado, esse aviso não sai.",
        errorVarsIncompletas: "Preencha a variável de cada variável numerada do modelo.",
        errorGuardar: "Não foi possível salvar a etapa.",
        chipTooltip: "Modelo escolhido: {{vars}}",
        category: {
          UTILITY: "Utilidade",
          MARKETING: "Marketing",
          AUTHENTICATION: "Autenticação",
        },
        superadmin: {
          overridesNote: "Esta escolha prevalece: se um passo tem modelo aqui, ele sai com ele mesmo que o mapeamento manual acima ou «Modelos de mensagem» mostrem outro (por exemplo recordatorio_turno).",
          title: "Modelo por lembrete",
          help: "Qual modelo de WhatsApp cada aviso programado desta empresa usa. É a mesma escolha que o admin vê em Ajustes › Lembretes › editar passo.",
          step: "Passo {{n}} · {{hours}} h antes",
          inactive: "inativo",
          current: "Hoje sai com: {{name}}",
          save: "Salvar",
          saved: "Modelo do passo salvo",
          applyAll: "Usar esta escolha em todos os passos",
          appliedAll: "Modelo aplicado a todos os passos",
          noSteps: "Esta empresa não tem passos de lembrete.",
          loadError: "Não foi possível carregar a configuração de lembretes.",
          marketing: "É de Marketing: a Meta cobra mais caro e pode limitar a entrega. Se houver um de Utilidade com o mesmo texto, prefira esse.",
        },
      },
      ajustes: {
        voiceTemplateDefault: "{nombre}, dirija-se a {consultorio}, com {profesional}. Repito: {nombre}, dirija-se a {consultorio}.",
        salaProfesionales: "{{professionalPlural_c}} (vazio = sem filtro)",
        salaSoloInicial: "Mostrar apenas a inicial do sobrenome",
        salaDing: "Ding dong a cada chamada",
        salaVoz: "Anúncio de voz",
        salaProximos: "Mostrar quem vem a seguir",
        salaAnteriores: "Mostrar quem já passou",
        nombreNegocio: "Nome do negócio",
        nombreNegocioPlaceholder: "Ex: Oficina Junín, Consultório Gazzera",
        avisoMail: {
          switchLabel: "Aviso por e-mail ativo",
          switchAyuda: "Desligado, nenhum aviso por e-mail é enviado na empresa, nem os de cada {{professional}}. Os endereços continuam salvos.",
          salteado: "não enviado ({{reason}})",
          motivo: { empresa_apagada: "aviso desligado na empresa", recurso_apagado: "aviso do recurso desligado" },
          titulo: "Aviso por e-mail quando o assistente gerencia um agendamento",
          cuando: "Um e-mail é enviado sempre que o assistente IA cria, reagenda ou cancela um agendamento pelo WhatsApp.",
          cuandoNo: "O que é carregado pelo painel, por importação de Excel ou pela API de avisos não gera aviso.",
          recursos: "Além disso, cada {{professional}} pode ter sua própria lista (em {{professionalPlural_c}}): recebe só os avisos dos seus {{appointmentPlural}}. Um endereço que esteja nas duas listas recebe um só e-mail.",
          label: "Endereços de aviso",
          placeholder: "ex: dono@empresa.com, recepcao@empresa.com",
          help: "Separe vários endereços com vírgulas (até 10). Vazio = sem aviso.",
          invalidas: "Estes endereços não são válidos: {{list}}",
          demasiadas: "É possível cadastrar até {{max}} endereços.",
          guardar: "Salvar endereços",
          ultimos: "Últimos avisos enviados",
          enviado: "enviado",
          fallo: "falhou ({{reason}})",
          evento: { created: "Criação", rescheduled: "Reagendamento", cancelled: "Cancelamento" },
          estado: {
            apagado: "O aviso por e-mail está desligado: nada é enviado. Os endereços continuam salvos.",
            recursos_apagados: "Os {{professionalPlural}} com endereço estão com o aviso desligado e não há endereços gerais: nada é enviado.",
            ok: "{{count}} endereço(s) são avisados com o e-mail de {{brand}}.",
            sin_direcciones: "Nenhum endereço cadastrado: nenhum aviso é enviado.",
            no_determinado: "Não foi possível verificar se esta empresa pode enviar e-mails.",
            sin_smtp: "Há endereços cadastrados, mas a marca desta empresa não tem servidor de e-mail configurado: os avisos não vão sair.",
            solo_recursos: "Sem endereços gerais: {{n}} de {{total}} {{professionalPlural}} avisam a própria lista.",
            okConRecursos: "São avisados {{count}} endereço(s) com o e-mail de {{brand}}, e além disso {{n}} de {{total}} {{professionalPlural}} avisam a própria lista.",
            ultimo_fallo: "O último aviso falhou ({{reason}})."
          }
        },
        grupoAgendaVentana: "Agenda → Janela de reserva",
        dias: "dias",
        metaEnRevision: "Em revisão",
        metaNoCreada: "Não criada",
        metaDentro24: "dentro de 24 horas",
        metaNoRequieren: "não exigem aprovação da Meta",
        metaAprobada: "modelo aprovado pela Meta",
        metaSoloLectura: "somente leitura",
        solicitudConfirmacion: "Solicitação de confirmação",
        opModoTitle: "Modo de operação",
        opModoDesc: "Define o que a IA faz quando não consegue resolver algo e para quem o caso vai.",
        opModoActivo: "Atual",
        opModoLocked: "Disponível em um plano superior — fale conosco para ativar",
        opEffectiveLabel: "Para quem os casos vão hoje:",
        opGuardarModo: "Salvar modo",
        opDestinatarioChat: "+ chat do WhatsApp",
        opModo: {
          desatendido: {
            title: "Não atendido",
            desc: "A IA atende sozinha. Se não conseguir resolver algo, deixa o caso para você ver na sua agenda. Não promete atendimento humano ao vivo.",
          },
          atendido: {
            title: "Atendido",
            desc: "A IA atende; os casos que não consegue resolver vão para a secretária / agendador.",
          },
          con_chat: {
            title: "Com chat",
            desc: "Além disso, sua equipe pode atender pelo chat do WhatsApp. A IA pode transferir para uma pessoa.",
          },
        },
        opDestinatario: {
          profesionales: "Os profissionais (cada caso aparece na agenda do profissional do agendamento)",
          rol: "A secretária / agendador",
          usuario: "Um usuário designado",
          admin: "O administrador",
        },
        grupoAsistente: "Assistente",
        // ── Interruptor da IA ─────────────────────────────────────────────
        // O texto diz o que faz E o que NÃO faz: desligar a IA não desliga os
        // lembretes, e essa confusão deixa uma empresa sem produto.
        iaOn: "O assistente responde as mensagens recebidas",
        iaOff: "O assistente NÃO responde: uma pessoa atende",
        iaDesc: "Com o assistente desligado, as mensagens recebidas não são passadas para a IA: ficam na caixa de Chats para uma pessoa atender. É um modo de operação, não um modo de manutenção — você pode deixá-lo desligado o tempo que quiser.",
        iaNoApagaRecordatorios: "⛔ Desligar o assistente NÃO desliga os lembretes: os avisos programados, as confirmações de reserva e as campanhas de saída continuam sendo enviados.",
        iaUltimoCambio: "Última alteração:",
        iaPorUsuario: "pelo usuário",
        iaPrendidaOk: "O assistente voltou a responder as mensagens recebidas.",
        iaApagadaOk: "Assistente desligado. As mensagens recebidas ficam na caixa. Os lembretes continuam saindo.",
        iaNoHabilitada: "O assistente não está habilitado para a sua conta",
        iaNoHabilitadaDesc: "Esta função não está habilitada para a sua conta. Fale conosco se quiser ativá-la.",
        remTitle: "Avisos programados",
        remOn: "Os avisos programados saem",
        remOff: "Os avisos programados NÃO saem",
        remDesc: "Os passos que você tiver configurado abaixo (30 dias antes, 24 horas antes, etc.). Cada aviso é uma mensagem de modelo do WhatsApp e tem custo. Desligá-los não apaga nada: ao ligar de novo, a fila retoma de onde estava.",
        remNoApagaConfirmacion: "⛔ Desligar os avisos programados NÃO desliga a confirmação enviada ao criar um agendamento (essa é controlada pela opção \"notificar\" do agendamento) nem as campanhas de saída.",
        remNoHabilitados: "Os avisos programados não estão habilitados para a sua conta",
        remNoHabilitadosDesc: "Esta função não está habilitada para a sua conta. Fale conosco se quiser ativá-la.",
        remPrendidosOk: "Os avisos programados voltam a sair. A fila retoma de onde estava.",
        remApagadosOk: "Avisos programados desligados. A confirmação ao criar um agendamento continua saindo.",
        asistenteTitle: "Assistente e dados da empresa",
        asistenteDesc: "Configure o nome e o tom do assistente, e os dados que ele responde a {{losPatientPlural}}.",
        asistenteNombre: "Nome do assistente",
        asistenteNombrePlaceholder: "Ex: SofIA",
        asistenteTono: "Tom",
        tonoCordial: "Cordial",
        tonoFormal: "Formal",
        tonoInformal: "Informal",
        asistenteInfoEmpresa: "Informações da empresa",
        asistenteInfoAyuda: "O assistente usa esses dados para responder às perguntas (onde ficam, horários, {{coberturaPlural}}, etc.). O que não estiver aqui e não for sobre a agenda, ele não inventa.",
        infoDireccion: "Endereço",
        infoDireccionPlaceholder: "Ex: Av. Colón 1234, Centro",
        infoTelefono: "Telefone",
        infoTelefonoPlaceholder: "Ex: 011-1234567",
        infoHorarios: "Horário de atendimento",
        infoHorariosPlaceholder: "Ex: Seg a Sex 9h às 18h",
        infoComoLlegar: "Como chegar",
        infoComoLlegarPlaceholder: "Ex: a meia quadra da praça, entrada pelo corredor",
        vocab: {
          title: "Vocabulário",
          desc: "Estas palavras são usadas em todo o sistema e também nas mensagens que o assistente envia. São herdadas do segmento; edite apenas o que quiser mudar.",
          rubroChip: "Segmento",
          plural: "Plural",
          propio: "Valor próprio",
          heredado: "Herdado",
          restaurar: "Restaurar valores do segmento",
          restaurado: "Vocabulário restaurado aos valores do segmento",
          scheduler: "Quem agenda (recepção)",
          room: "Consultório / box",
          generoTitulo: "o / a",
          generoAyuda: "Marque se a palavra é masculina ou feminina. Serve para o sistema escrever bem o artigo (\"a Filial\", não \"o Filial\") em todas as telas.",
          generoM: "o",
          generoF: "a",
          patient: "Pessoa atendida",
          professional: "Profissional",
          appointment: "Agendamento",
          specialty: "Especialidade",
          service: "Serviço",
          waitingRoom: "Sala de espera",
          cobertura: "Convênio (seguro / garantia)",
          patientName: "Campo: Nome",
          patientPhone: "Campo: Telefone",
        },
        infoObrasSociales: "{{coberturaPlural_c}}",
        infoObrasSocialesPlaceholder: "Ex: PAMI, OSDE, particular (ou 'não trabalhamos com {{cobertura}}')",
        infoFormasPago: "Formas de pagamento",
        infoFormasPagoPlaceholder: "Ex: dinheiro, débito, transferência",
        infoAdicional: "Informações adicionais",
        infoAdicionalPlaceholder: "Qualquer outro dado que o assistente deva saber para responder",
        grupoGeneral: "Geral",
        grupoRecordatorios: "Lembretes",
        grupoAgenda: "Agenda",
        grupoPermisos: "Permissões e painel",
        rwTitle: "Janela de envio de lembretes",
        rwDesc: "Faixa horária e dias em que os lembretes podem ser enviados.",
        rwInheritedBadge: "Herdado",
        rwOwnBadge: "Configuração própria",
        rwInheritedFrom: "Esta empresa usa o padrão global do TurnosIA. Valor efetivo:",
        rwEffectivePreview: "Valor efetivo",
        rwHoraDesde: "Hora de",
        rwHoraHasta: "Hora até",
        rwDiasEvitar: "Dias a evitar",
        rwSabadoHasta: "Sábado até",
        rwSabadoPropio: "Sábado com horário próprio",
        rwUsarPropia: "Usar configuração própria",
        rwVolverHeredar: "Voltar a herdar",
        rwGuardar: "Salvar janela",
        rwHelp: "Os lembretes que cairiam fora desta faixa ou em um dia evitado são movidos para o momento válido mais próximo anterior.",
        rwOkGuardado: "Janela de envio salva",
        rwOkHeredar: "Voltou a herdar o padrão global",
        rwDia_dom: "Dom",
        rwDia_lun: "Seg",
        rwDia_mar: "Ter",
        rwDia_mie: "Qua",
        rwDia_jue: "Qui",
        rwDia_vie: "Sex",
        rwDia_sab: "Sáb",
        activar: "Ativar",
        configuracionGeneral: "Configurações gerais",
        parametrosDesc: "Parâmetros de integração e comportamento do módulo.",
        urlWebhookN8n: "Webhook n8n (TurnosIA)",
        urlWebhookN8nHelp: "As mensagens que chegam pela linha do TurnosIA são enviadas para este webhook.",
        webhookConfigured: "Configurado",
        webhookNotConfigured: "Não configurado",
        webhookManagedBySuperadmin: "Gerenciado pela equipe (painel superadmin).",
        guardarConfig: "Salvar configurações",
        secuenciaRecordatorios: "Sequência de lembretes",
        secuenciaDesc: "Quando e que tipo de mensagem é enviada antes. Só pode haver um pedido de confirmação por {{appointment}}.",
        headerOrden: "Ordem",
        headerHorasAntes: "Horas antes",
        headerTipo: "Tipo",
        headerActivo: "Ativo",
        headerAcciones: "Ações",
        sinPasos: "Sem etapas configuradas",
        plantillasMensajes: "Modelos de mensagens",
        plantillasDesc: "Textos enviados em cada situação. Variáveis disponíveis:",
        guardarPlantilla: "Salvar",
        especialidades: "{{specialtyPlural_c}}",
        especialidadesDesc: "Como se classifica quem atende. Você pode adicionar, editar ou desativar.",
        sinEspecialidades: "Você ainda não cadastrou {{specialtyPlural}}.",
        cancelarEspecialidad: "Cancelar",
        agregarEspecialidad: "Adicionar {{specialty}}",
        cfTitle: "Campos personalizados",
        cfDesc: "Campos extras pedidos ao cadastrar (ex. Placa, Notas). Sua empresa os define.",
        cfAdd: "Adicionar campo",
        cfEmpty: "Sem campos personalizados configurados",
        cfColLabel: "Rótulo",
        cfColType: "Tipo",
        cfColRequired: "Obrigatório",
        cfColCalendar: "No calendário",
        cfCalendarHelp: "Aparece no cartão do agendamento no calendário, antes do nome (ex.: a placa). Máximo de 2 campos.",
        cfColOrder: "Ordem",
        cfEdit: "Editar campo",
        cfNew: "Novo campo personalizado",
        cfKeyLabel: "Chave (key)",
        cfKeyHelp: "Identificador estável, sem espaços. Não pode ser alterado depois.",
        cfOptionsLabel: "Opções (separadas por vírgula)",
        cfOptionsHelp: "Ex: Vermelho, Verde, Azul",
        cfErrorLabel: "O rótulo é obrigatório",
        cfErrorKey: "A chave é obrigatória",
        cfErrorOptions: "As opções são obrigatórias para o tipo lista",
        cfType_text: "Texto",
        cfType_textarea: "Texto longo",
        cfType_number: "Número",
        cfType_date: "Data",
        cfType_select: "Lista",
        tplTitle: "Aplicar modelo de setor",
        tplDesc: "Adiciona especialidades, campos e termos do setor escolhido. Não sobrescreve o que você já editou.",
        tplSelectLabel: "Setor",
        tplSelectPlaceholder: "Selecionar...",
        tplApply: "Aplicar modelo",
        tplCurrent: "Setor atual",
        tplName_generico: "Genérico",
        tplName_odontologia: "Odontologia",
        tplName_taller: "Oficina",
        tplConfirmTitle: "Aplicar modelo?",
        tplConfirmBody: "Adiciona especialidades, campos personalizados e terminologia do setor. Não sobrescreve o que você já editou.",
        tplAplicada: "Modelo aplicado",
        outgoingTitle: "Linha do TurnosIA",
        outgoingDesc: "Número dedicado ao TurnosIA. Usado para enviar lembretes e para receber as conversas do assistente.",
        outgoingLabel: "Linha do TurnosIA",
        outgoingDefault: "Usar a conexão padrão",
        outgoingEmpty: "Não há conexões de WhatsApp nesta empresa.",
        outgoingHint: "Recomenda-se um número QR: os avisos do TurnosIA são texto livre.",
        outgoingMetaWarn: "META exige modelo aprovado. Os avisos do TurnosIA são texto livre — escolha um número QR.",
        lineStatusFree: "Livre",
        lineStatusCurrent: "Linha atual do TurnosIA",
        lineStatusCompanyBot: "Em uso pelo bot da empresa",
        lineStatusOtherBot: "Em uso por outro bot (webhook próprio)",
        lineOccupiedTitle: "Esta linha já está em uso",
        lineOccupiedCompanyBot: "Esta linha hoje atende o bot da empresa. Se você a atribuir ao TurnosIA, as mensagens que entrarem por ela deixarão de ir para esse bot.",
        lineOccupiedOtherBot: "Esta linha hoje é usada por outro bot (tem seu próprio webhook). Se você a atribuir ao TurnosIA, ela deixará de receber essas mensagens.",
        lineOccupiedConfirm: "Atribuir mesmo assim",
        lineOccupiedCancel: "Cancelar",
        textoPara: "Texto para",
        salasEspera: "{{waitingRoomPlural_c}}",
        salasDesc: "As telas que vê quem espera. Cada uma pode mostrar quem você escolher.",
        agregarSala: "Adicionar sala",
        sinSalas: "Sem salas configuradas.",
        todosProfesionales: "Sem filtro",
        featureNoHabilitada: "Esta funcionalidade não está habilitada para a sua empresa. Entre em contato com o administrador para ativá-la.",
        templateBookingConfirmed: "Confirmação de agendamento",
        templateAppointmentRescheduled: "Aviso de reagendamento",
        templateReminder: "Lembrete simples",
        templateConfirmationRequest: "Solicitação de confirmação",
        templateRebalanceOffer: "Oferta de rebalanceamento",
        templateWaitinglistOffer: "Oferta da lista de espera",
        templateCancellationConfirmed: "Aviso de cancelamento",
        templateWaitinglistAdded: "Adicionado à lista de espera",
        templateLlamarSiguiente: "É a sua vez (chamar próximo)",
        templateArrivalCheck: "Você está chegando? (horário iniciado sem chegada)",
        arrivalTitle: "Consulta de chegada",
        arrivalHelp: "Se um horário confirmado começou há alguns minutos e ninguém marcou «Chegou» na agenda, pergunta-se ao cliente se está chegando. Se responder que já está, o assistente registra a chegada. Respeita o interruptor de avisos programados.",
        arrivalSwitch: "Perguntar «você está chegando?»",
        arrivalMinutes: "Minutos após o início do horário",
        arrivalMinutesHelp: "Entre 5 e 120. Vazio = 10.",
        arrivalWarn: "⚠ Se a recepção não marcar «Chegou», a mensagem pode chegar a quem já está no local.",
        errorSoloUnaConfirmacion: "Só pode haver um pedido de confirmação por {{appointment}}.",
        errorNombreRequerido: "O nome é obrigatório",
        errorGuardar: "Erro ao salvar",
        errorDesactivar: "Não foi possível desativar",
        errorSlugRequerido: "Nome e slug são obrigatórios",
        slugEmpresa: "Identificador da empresa (slug)",
        helperSlug: "Sem espaços ou caracteres especiais",
        idDepartamento: "ID do departamento WAIA",
        helperDepartamento: "Para direcionar tickets a este departamento",
        rebalanceoAuto: "Ativar rebalanceamento automático ao cancelar consultas",
        tiempoRespuesta: "Tempo de resposta da oferta (minutos)",
        helperTiempoRespuesta: "Minutos para o candidato aceitar uma oferta",
        diasListaEspera: "Dias na lista de espera",
        helperDiasLista: "Dias que alguém permanece na lista",
        ventanaAdelantamiento: "Janela de adiantamento (dias)",
        helperVentana: "Dias à frente para buscar candidatos",
        exclusionCancelar: "Exclusão após cancelamento (horas)",
        helperExclusion: "Horas de exclusão anti-loop",
        duracionEsperada: "Duração esperada, em minutos",
        helperDuracion: "Aplica-se quando a consulta não indica {{unService}}. Ordem: a do {{service}} escolhido; se não houver {{service}}, esta; se esta ficar vazia, 30 minutos. Também serve para calcular se está adiantado ou atrasado.",
        vrTitle: "Janela de agendamento",
        vrDesc: "Até quando para a frente é possível marcar {{appointmentPlural}}, e a partir de quando o assistente pode marcá-los pelo WhatsApp.",
        vrTechoLabel: "Com quanta antecedência é possível agendar",
        vrTechoHelp: "Máximo para a frente. Vale para o painel e para o assistente. Entre {{min}} e {{max}}.",
        vrUnitLabel: "Unidade",
        vrUnitDays: "dias",
        vrUnitMonths: "meses",
        vrPisoLabel: "Antecedência mínima (somente pelo WhatsApp)",
        vrPisoHelp: "Os próximos {{n}} dias ficam reservados para quem liga ou vem até aqui; o assistente não os oferece, mas por aqui você continua podendo agendá-los.",
        vrPisoHelpZero: "Sem mínimo: o assistente pode oferecer {{appointmentPlural}} para hoje mesmo. Defina um número de dias para reservar os primeiros dias para quem liga ou vem até aqui.",
        vrConfirmSkipLabel: "Não pedir confirmação se foi agendado pelo WhatsApp com menos de N dias",
        vrConfirmSkipHelp: "Se {{elPatient}} agendou pelo WhatsApp e faltam menos de {{n}} dias, não se pede confirmação: acabou de escolher. Vazio = {{n}} dias.",
        vrConfirmSkipOff: "0 = a confirmação é sempre pedida, mesmo que {{elPatient}} tenha agendado pelo WhatsApp há pouco.",
        vrBotSlotLimitLabel: "Horários que o assistente recebe por consulta",
        vrBotSlotLimitHelp: "O assistente escolhe entre os {{n}} primeiros horários de cada consulta. Com várias filiais, um número baixo se enche com os primeiros horários da manhã e a tarde nunca chega até ele. Vazio = 20.",
        pideConfirmacion: "Pede confirmação",
        recordatorio: "Lembrete",
        si: "Sim",
        no: "Não",
        editar: "Editar",
        eliminar: "Excluir",
        editarEspecialidad: "Editar {{specialty}}",
        nuevaEspecialidad: "Adicionar {{specialty}}",
        nombreEspecialidad: "Nome",
        guardarEspecialidad: "Salvar",
        activa: "Ativa",
        inactiva: "Inativa",
        editarNombre: "Editar nome",
        desactivar: "Desativar",
        editarSala: "Editar sala",
        nuevaSala: "Adicionar {{waitingRoom}}",
        nombreSala: "Nome *",
        slugSala: "Slug *",
        helperSlugSala: "Somente minúsculas e hífens. Exemplo: sala-principal",
        plantillaVoz: "Modelo de voz",
        helperVoz: "Variáveis: {nombre} {consultorio} {profesional}",
        guardarSala: "Salvar",
        copiarUrl: "Copiar URL",
        sinLinkCorto: "Sem link curto",
        regenerarLink: "Regenerar e copiar link curto",
        generarLink: "Gerar link curto",
        linkCopiado: "Link copiado",
        errorLink: "Erro ao gerar o link curto",
        editarPaso: "Editar etapa",
        agregarPaso: "Adicionar etapa",
        horasAntes: "Horas antes",
        tipoRecordatorio: "Tipo",
        activoSwitch: "Ativo",
        guardarPaso: "Salvar",
        guardadoOk: "Salvo com sucesso",
        permisosProfesional: "Permissões de quem atende",
        permisosProfesionalDesc: "O que pode fazer na própria agenda, a partir do seu calendário.",
        professionalCanCreate: "Pode criar {{appointmentPlural}} na própria agenda",
        professionalCanMove: "Pode reagendar (mover ou arrastar) os seus",
        panelDeTurno: "Painel de detalhes",
        panelDeTurnoDesc: "Quais ações aparecem ao abrir o detalhe.",
        panelAction: {
          status: "Mudar status",
          move: "Mover",
          reAvisar: "Reavisar por WhatsApp",
          cancelReason: "Cancelar com motivo",
          openChat: "Abrir o chat",
          history: "Histórico",
          statusLog: "Registro de mudanças de status",
          waitingRoom: "Chamar ({{waitingRoom}})",
          followUp: "Acompanhamento",
          note: "Notas",
          showPhone: "Mostrar telefone",
          delete: "Excluir",
        },
        localizacion: "Localização",
        localizacionDesc: "Fuso horário e idioma de datas/horas para toda a empresa.",
        timezone: "Fuso horário",
        locale: "Idioma das datas",
      },
      internalChat: {
        placeholder: "Escrever mensagem...",
        para: "Para",
        todos: "Todos",
        chatInterno: "Chat interno",
        mediaTooLarge: "Os arquivos excedem o limite de 18 MB. Envie menos de cada vez.",
        quotedNotLoaded: "A mensagem citada não está mais carregada nesta conversa.",
        jumpToQuoted: "Ir para a mensagem citada",
      },
      salaEspera: {
        cargando: "Carregando…",
        errorConexion: "Não foi possível conectar ao serviço.",
        fallbackNombre: "{{waitingRoom_c}}",
        enAtencion: "⬤ Em atendimento agora",
        aguardando: "Aguardando a chamada…",
        proximosTurnos: "A seguir",
        sinProximos: "Não há ninguém esperando",
        yaAtendidos: "Já passaram",
        sinPrevios: "Ainda não passou ninguém hoje",
        linkNoEncontrado: "Não encontramos essa tela",
        llamado: "Chamado",
        enAtencionCard: "Em atendimento",
        min: "min",
      },
      sidebar: {
        empresas: "Empresas",
        dashboardAdmin: "Dashboard",
        comunicados: "Comunicados",
        logsDelSistema: "Logs do sistema",
        avisos: "Avisos",
        apis: "APIs",
        turnosIA: "TurnosIA",
        citas: "Consultas",
        changelog: "Changelog",
        turnos: "TurnosIA",
        pendientes: "Pendentes",
        estadisticas: "Estatísticas",
        reportes: "Relatórios",
        etiquetas: "Etiquetas",
        estadosDeContacto: "Status de Contato",
        matchprop: "MatchProp",
        aiServices: "Serviços de IA",
        aiStats: "Estatísticas IA",
        connectionsOverview: "Conexões (global)",
      },
      superAdminConnections: {
        qrSection: "Linhas QR — saúde dos grupos",
        qrHelp: "Conta, desde a última inicialização do servidor, as mensagens de grupo que chegaram e as que não puderam ser descriptografadas. Se uma linha diz estar conectada mas não recebe seus grupos, aparece em vermelho. O WAIA não a reconecta sozinho: é preciso desconectar e escanear o QR de novo em Conexões.",
        qrEmpty: "Não há linhas QR.",
        qrGroups: "Grupos",
        qrGroupOk: "Grupo OK",
        qrGroupFail: "Grupo sem descriptografar",
        qrDirectOk: "Individual OK",
        qrLastGroup: "Última de grupo",
        qrResync: "Resync de grupos",
        qrResyncCount: "{{count}} grupos",
        qrResyncError: "Erro: {{error}}",
        qrPrior: "Mensagens de grupo nas 24 h antes da inicialização: {{count}}",
        qrStatus: {
          ok: "OK",
          sin_datos: "Ainda sem dados",
          grupos_sin_descifrar: "Grupos sem descriptografar",
          grupos_callados: "Grupos em silêncio",
        },
        title: "Conexões por empresa",
        subtitle: "Estado de todas as conexões de WhatsApp e saúde das linhas Meta, em todas as empresas.",
        refresh: "Atualizar",
        semaphoreSection: "Semáforo de conexões",
        semaphoreHelp: "Resumo por empresa. Verde: todas conectadas. Amarelo: reconectando ou queda parcial. Vermelho: queda sem conexão ativa. Cinza: sem conexões.",
        company: "Empresa",
        state: "Estado",
        total: "Total",
        connected: "Conectadas",
        transitional: "Em transição",
        down: "Quedas",
        lastChange: "Última alteração",
        semaphore: {
          green: "Operacional",
          yellow: "Atenção",
          red: "Queda",
          none: "Sem conexões",
        },
        metaSection: "Linhas Meta",
        metaHelp: "Saúde de cada linha WhatsApp Cloud API / Coexistência.",
        metaEmpty: "Nenhuma linha Meta configurada.",
        line: "Linha",
        type: "Tipo",
        coexistence: "Coexistência",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        status: "Estado",
        health: "Saúde",
        historySync: {
          title: "Histórico",
          attempts: "{{count}} tentativa(s)",
          requestedAt: "Conectada: {{date}}",
          nextAt: "Próxima tentativa: {{date}}",
          lastError: "Último erro: {{error}}",
          notSharedAt: "Aviso da Meta: {{date}}",
          status: {
            pending: "Pendente",
            success: "Pedido OK",
            failed: "Falhou",
            expired: "Expirado",
            skipped: "Não pedido",
            not_shared: "O cliente não compartilhou o histórico",
          },
        },
      },
      superAdminAI: {
        title: "Serviços de IA — Configuração por empresa",
        subtitle: "Ative os Serviços de IA por empresa e carregue as chaves dos provedores (OpenAI, Anthropic, Gemini) como reserva.",
        company: "Empresa",
        selectCompany: "Selecionar empresa",
        enabled: "Ativar Serviços de IA",
        enabledHelp: "Ativa a seção de Serviços de IA para esta empresa. O administrador poderá configurar os serviços e suas chaves.",
        keysSection: "Chaves dos provedores (reserva)",
        keysHelp: "As chaves do administrador têm prioridade. Estas são uma reserva opcional.",
        providerEnabled: "ativado",
        apiKey: "Chave da {{provider}}",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Não configurada",
        save: "Salvar",
        saveOk: "Configuração salva",
        showKey: "Ver chave",
        hideKey: "Ocultar chave",
      },
      aiServices: {
        title: "Serviços de IA",
        notEnabled: "Serviços de IA não está ativado para sua empresa. Contate o suporte.",
        transcriptLabel: "Transcrição",
        transcribeBtn: "Transcrever áudio",
        transcribing: "Transcrevendo…",
        failedMsg: "Não foi possível transcrever",
        retry: "Tentar novamente",
        consumptionWarning: "⚠ Os serviços de IA consomem tokens das suas chaves. Cada uso (por exemplo, transcrever um áudio) tem custo na sua conta do provedor.",
        keysSection: "Chaves de IA",
        keysHelp: "Carregue suas próprias chaves por provedor. É seu gasto: as chamadas são cobradas nestas chaves.",
        apiKey: "Chave da {{provider}}",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Não configurada",
        servicesSection: "Serviços",
        provider: "Provedor",
        model: "Modelo",
        mode: "Modo",
        modeHuman: "Modo (atendimento humano)",
        aiAttendedMode: "Atendimento IA",
        aiAttendedSiempre: "Sempre transcrever",
        aiAttendedNunca: "Nunca transcrever",
        aiAttendedHelp: "Quando a IA atende o chat, define se o áudio é convertido em texto para que a IA o entenda.",
        limitSection: "Limite antiabuso",
        limitHelp: "0 = sem limite. Aplica-se apenas à transcrição automática; o botão manual nunca é limitado.",
        maxPerWindow: "Máx. áudios por contato",
        windowMinutes: "a cada (minutos)",
        notSupported: "não suporta",
        transcribeProviderTip: "Anthropic não suporta transcrição de áudio. Use OpenAI ou Gemini.",
        modes: {
          auto: "Automático (sempre)",
          a_pedido: "Sob demanda (manual)",
          nunca: "Nunca",
        },
        transcription: {
          title: "Transcrição de áudio",
          help: "Converte os áudios recebidos em texto. Escolha provedor, modelo e quando transcrever.",
        },
        save: "Salvar",
        saveOk: "Salvo",
        showKey: "Ver chave",
        hideKey: "Ocultar chave",
      },
      superAIStats: {
        title: "Estatísticas por Assistente IA — Configuração",
        company: "Empresa",
        selectCompany: "Escolha uma empresa",
        enabled: "Módulo habilitado",
        enabledHelp:
          "Se desligado, o módulo não aparece no menu do admin nem fornece dados.",
        visibilityTitle: "Visibilidade dos painéis",
        visibilityHelp:
          "Escolha quais painéis o cliente vê. Não configurável com o módulo desligado.",
        panels: {
          horasAhorradas: "Horas economizadas",
          cobertura: "Cobertura 24/7",
          reclamosATiempo: "Reclamações a tempo",
          iaVsHumano: "IA vs humano",
          recomendaciones: "Recomendações",
          embudoKpis: "Funil e KPIs",
          objetoReclamo: "Objeto da reclamação",
          tags: "Etiquetas",
        },
        saveCompany: "Salvar empresa",
        saveOk: "Configuração salva",
        saving: "Salvando…",
        assistantsTitle: "Assistentes",
        noAssistants: "Esta empresa ainda não tem assistentes.",
        catalogName: "Nome no catálogo",
        displayName: "Nome visível",
        type: "Tipo",
        types: {
          satisfaccion: "Satisfação",
          venta: "Venda",
          recupero: "Recuperação",
        },
        technicalConfig: "Configuração técnica",
        tech: {
          humanClosingHour: "Hora fecho humano",
          humanWorkMarginHours: "Margem trabalho (hs)",
          timeoutHours: "Timeout (hs)",
          sinRespuestaWarnPct: "Limite sem resposta (0-1)",
          queueRoles: "Papéis de fila (JSON)",
          jsonFieldMap: "Mapa de campos (JSON)",
        },
        saveAssistant: "Salvar assistente",
        saveAssistantOk: "Assistente salvo",
        invalidJson: "JSON inválido em papéis de fila ou mapa de campos.",
      },
      superMatchProp: {
        title: "MatchProp — Configuração por empresa",
        subtitle: "Detector de pedidos de imóveis em grupos do WhatsApp. Configure inventário, LLM e modo de teste por empresa.",
        company: "Empresa",
        selectCompany: "Selecionar empresa",
        enabled: "Habilitar MatchProp",
        enabledHelp: "Ativa o monitoramento de grupos e a geração de alertas para esta empresa.",
        dryRun: "Modo teste (dry-run)",
        dryRunHelp: "No teste, os alertas aparecem com selo TESTE e não são considerados envio real.",
        llmSection: "Modelo de linguagem (LLM)",
        llmProvider: "Provedor",
        llmModel: "Modelo",
        llmKey: "API key do LLM",
        inventorySection: "Inventário",
        inventorySource: "Fonte do inventário",
        tokkoKey: "API key do Tokko",
        gvaId: "ID Imobiliária (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "A credencial GVA (ID + token) é fornecida pelo provedor, não pelo cliente.",
        ttlMinutes: "TTL do inventário (minutos)",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Não configurada",
        lastSync: "Última sincronização",
        save: "Salvar",
        forceSync: "Forçar atualização agora",
        saveOk: "Configuração salva",
        syncOk: "Sincronizadas {{count}} propriedades",
        showKey: "Ver chave",
        hideKey: "Ocultar chave",
      },
      matchpropAdmin: {
        title: "MatchProp",
        notEnabled: "MatchProp não está habilitado para sua empresa. Contate o suporte.",
        groupsSection: "Grupos a monitorar",
        groupsHelp: "Escolha quais grupos o MatchProp deve analisar em busca de pedidos.",
        noGroups: "Nenhum grupo de WhatsApp conhecido ainda.",
        groupOn: "Grupo ativado",
        groupOff: "Grupo desativado",
        tolerancesSection: "Tolerâncias de correspondência",
        dormsPlus: "Quartos a mais aceitos",
        dormsPlusHelp: "Aceitar imóveis com até X quartos a MAIS que o pedido.",
        dormsMinus: "Quartos a menos aceitos",
        dormsMinusHelp: "Aceitar imóveis com até X quartos a MENOS que o pedido.",
        precioMargin: "Margem de preço (%)",
        precioMarginHelp: "Aceitar imóveis até X% acima do orçamento.",
        topN: "Correspondências por alerta",
        topNHelp: "Quantas correspondências mostrar em cada alerta.",
        minTopLevel: "Nível mínimo para avisar",
        minTopLevelHelp: "EXATO avisa só correspondências exatas; PARECIDO inclui aproximadas.",
        levelExact: "EXATO",
        levelSimilar: "PARECIDO",
        save: "Salvar",
        saveOk: "Salvo",
        aiSection: "Inteligência Artificial",
        llmProvider: "Provedor de IA",
        llmModel: "Modelo",
        llmKey: "API key de IA",
        comingSoon: "em breve",
        sourceSection: "Fonte de inventário",
        sourceLabel: "Fonte",
        sourceNotSet: "Seu provedor ainda não configurou a fonte de inventário.",
        crmKey: "API key do CRM",
        gvaId: "ID Imobiliária (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "Credencial fornecida pela GVA.",
        keyConfigured: "•••• (configurada)",
        keyNotSet: "Não configurada",
        showKey: "Ver chave",
        hideKey: "Ocultar chave",
        consumptionWarning: "⚠ Ative o MatchProp apenas em grupos de PEDIDOS de imóveis. Cada mensagem de um grupo monitorado é analisada com IA e consome tokens da sua API. Ativar grupos que não são de pedidos gera gasto desnecessário.",
        confirmTitle: "Confirmar monitoramento do grupo",
        confirmBody: "O grupo \"{{group}}\" será analisado com IA a cada mensagem, consumindo seus tokens. Confirma?",
        cancel: "Cancelar",
        confirm: "Ativar",
      },
      tags: {
        titulo: "Etiquetas",
        nueva: "Nova etiqueta",
        creada: "Etiqueta criada",
        eliminada: "Etiqueta excluída",
        nombre: "Nome",
        color: "Cor",
        vistaPrevia: "Pré-visualização",
        cancelar: "Cancelar",
        crear: "Criar",
        headerColor: "Cor",
        headerNombre: "Nome",
        headerAcciones: "Ações",
        sinEtiquetas: "Sem etiquetas",
      },
      stats: {
        titulo: "Estatísticas e ROI",
        ticketsHoy: "Tickets hoje",
        ticketsSemana: "Tickets esta semana",
        ticketesMes: "Tickets este mês",
        tiempoRespuesta: "Tempo médio de resposta",
        impactoIA: "Impacto da IA este mês",
        horasAhorradas: "{{hours}} horas economizadas",
        equivalente: "Equivalente a {{days}} dias de trabalho · {{ai}} mensagens respondidas pela IA vs {{human}} por humanos",
        conversacionesPorDia: "Conversas por dia (últimos 30 dias)",
        mensajesIAvsHumano: "Mensagens: IA vs Humano",
        sinDatos: "Sem dados ainda",
        tickets: "Tickets",
        fecha: "Data",
        ia: "IA",
        humano: "Humano",
      },
      contactStates: {
        entryStage: {
          help: "Etapa de entrada do Funnel: os contatos sem etapa aparecem aqui. Escolha apenas uma (a coluna que recebe as novas conversas).",
          radio: "Usar como entrada do Funnel",
          radioSelected: "Entrada do Funnel (clique para remover)",
          radioDisabled: "Apenas uma etapa ativa pode ser a entrada do Funnel",
          badge: "Entrada do Funnel",
          setOk: "Etapa de entrada atualizada",
          clearedOk: "O Funnel não tem mais etapa de entrada",
        },
        crmSwitch: {
          title: "Funnel",
          label: "Ativar Funnel",
          desc: "Mostra os contatos em etapas (colunas por estado) e permite movê-los arrastando. Aparece no menu para toda a equipe.",
          needsActive: "Ative pelo menos um estado para poder ligar o Funnel.",
          lastActiveTitle: "Desativando o último estado",
          lastActiveText: "O Funnel está ligado e este é o último estado ativo. Se você desativá-lo, o Funnel ficará indisponível até que outro estado seja ativado.",
          lastActiveConfirm: "Desativar mesmo assim",
          enabledOk: "Funnel ativado",
          disabledOk: "Funnel desativado",
        },
        titulo: "Status de Contato — Admin",
        estadosContacto: "Status de Contato",
        agregarEstado: "Adicionar status",
        motivosPerdida: "Motivos de Perda",
        agregarMotivo: "Adicionar motivo",
        noHayMotivos: "Sem motivos de perda. Adicione um para que apareça ao marcar um contato como Perdido.",
        cierreAutomatico: "Fechamento Automático de Tickets",
        cerrarGanado: "Fechar ticket ao marcar como Ganho",
        descCerrarGanado: "Quando um contato é marcado como Ganho, o ticket ativo é fechado automaticamente.",
        cerrarPerdido: "Fechar ticket ao marcar como Perdido",
        descCerrarPerdido: "Quando um contato é marcado como Perdido, o ticket ativo é fechado automaticamente.",
        guardarConfig: "Salvar configurações",
        sistema: "Sistema",
        desactivar: "Desativar",
        activar: "Ativar",
        subir: "Mover para cima",
        bajar: "Mover para baixo",
        editar: "Editar",
        eliminar: "Excluir",
        noEliminarSistema: "Não é possível excluir um status do sistema",
        ocultarSistema: "Status do sistema. Você pode ocultá-lo mas não excluí-lo.",
        editarEstado: "Editar status",
        nuevoEstado: "Novo status",
        editarMotivo: "Editar motivo",
        nuevoMotivo: "Novo motivo de perda",
        nombre: "Nome",
        cancelar: "Cancelar",
        guardar: "Salvar",
        nombreObligatorio: "O nome é obrigatório",
        estadoActualizado: "Status atualizado",
        estadoCreado: "Status criado",
        estadoEliminado: "Status excluído. Os contatos atribuídos ficaram sem status.",
        motivoActualizado: "Motivo atualizado",
        motivoCreado: "Motivo criado",
        motivoEliminado: "Motivo excluído",
        configuracionGuardada: "Configurações salvas",
        confirmarEliminacion: "Confirmar exclusão",
        eliminarEstado: "Excluir este status? Os contatos com este status ficarão sem status atribuído.",
        eliminarMotivo: "Excluir este motivo de perda?",
      },
      pendingDashboard: {
        titulo: "Painel de Pendentes",
        actualizar: "Atualizar",
        actualizadoAt: "Atualizado {{hora}}",
        mios: "Meus",
        vencidos: "Vencidos",
        hoy: "Hoje",
        proximos7d: "Próximos 7 dias",
        sinFecha: "Sem data",
        totalActivos: "Total ativos",
        ver: "Ver",
        soloMios: "Somente meus",
        miEquipo: "Minha equipe",
        todos: "Todos",
        asesor: "Atendente",
        motivo: "Motivo",
        limpiarFiltros: "Limpar filtros",
        sinPendientesGrupo: "Sem pendentes neste grupo",
        sinAsignar: "Sem responsável — equipe",
        asignadoA: "Atribuído a: {{name}}",
        ultimaAccion: "Última ação: {{name}} · {{date}}",
        tomar: "Assumir",
        reprogramar: "Reagendar",
        resolver: "Resolver",
        chat: "Chat",
        asignarmeEste: "Atribuir este pendente a mim",
        marcarResuelto: "Marcar como resolvido",
        irAlChat: "Ir ao chat",
        pendienteResuelto: "Pendente resolvido",
        pendienteReprogramado: "Pendente reagendado",
        pendienteAsignado: "Pendente atribuído a você",
        reprogramarTitulo: "Reagendar pendente",
        cuando: "Quando?",
        fechaYHora: "Data e hora",
        cancelar: "Cancelar",
        guardar: "Salvar",
        sinFechaChip: "sem data",
        sinResponsable: "sem responsável",
        vencidoText: "vencido",
        venceText: "vence",
        hoyText: "hoje",
        proximos7dias: "Próximos 7 dias",
        sinFechaGrupo: "Sem data",
      },
      reports: {
        titulo: "Relatórios",
        desde: "De",
        hasta: "Até",
        agente: "Atendente",
        todos: "Todos",
        cola: "Fila",
        todas: "Todas",
        motivoContacto: "Motivo de contato",
        generar: "Gerar",
        exportarCSV: "Exportar CSV",
        totalChats: "Total de chats",
        cerrados: "Fechados",
        enAtencion: "Em atendimento",
        esperando: "Aguardando",
        sinRespuesta: "Sem resposta",
        respPromedio: "Resp. média",
        chatsPorDia: "Chats por dia",
        chats: "Chats",
        fecha: "Data",
        estadoChats: "Status dos chats",
        sinDatos: "Sem dados",
        chatsPorAgente: "Chats por atendente",
        chatsPorCola: "Chats por fila",
        pctTotal: "% do total",
        chatsPorMotivo: "Chats por motivo de contato",
        motivo: "Motivo",
        ia: "IA",
        humano: "Humano",
        abiertos: "Abertos",
        pendientes: "Pendentes",
        mensajesIAvsHumano: "Mensagens: IA vs Humano",
      },
      contacts: {
        title: "Contatos",
        toasts: { deleted: "Contato excluído com sucesso!" },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          importTitlte: "Importar contatos",
          deleteMessage: "Tem certeza de que deseja excluir este contato? Todos os chats relacionados serão perdidos.",
          importMessage: "Serão trazidos para o WAIA os contatos salvos no telefone da conexão de WhatsApp padrão (apenas os que têm número). Nenhuma mensagem é enviada. Continuar?",
        },
        importMenu: {
          tooltip: "Carregar contatos do telefone do WhatsApp ou de um arquivo CSV",
          phone: "Do telefone (WhatsApp)",
          phoneHelp: "Traz os contatos salvos no telefone da conexão padrão. Os que já existem não são alterados.",
          csv: "De um arquivo CSV",
          csvHelp: "Envie uma planilha (Excel → Salvar como CSV) e escolha qual coluna é o nome, o número, o e-mail etc.",
        },
        buttons: {
          import: "Importar",
          add: "Adicionar contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
        tabContactos: "Contatos",
        tabClientes: "Contatos",
        tabPendientes: "Pendentes",
        tabDescartados: "Descartados",
        tabTodos: "Todos",
        colNombreWA: "Nome WhatsApp",
        colTipoCliente: "Tipo de cliente",
        colNumero: "Número",
        colEmpresa: "Empresa",
        colNotas: "Notas",
        colAtendidoPor: "Atendido por",
        colTotalChats: "Total de chats",
        colUltimaActividad: "Última atividade",
        sinNombre: "Sem nome",
        moveTo_qualified: "Contatos",
        moveTo_pending: "Pendentes",
        moveTo_disqualified: "Descartados",
        movedToast: "Contato movido para {{tab}}",
        undoButton: "Desfazer",
        menuMoveTo_qualified: "Passar a Contatos",
        menuMoveTo_pending: "Passar a Pendentes",
        menuMoveTo_disqualified: "Passar a Descartados",
        importando: "Importando contatos em segundo plano...",
        importOk: "Importados {{imported}} contatos. {{skipped}} já existiam.",
        importDone: "Importação concluída.",
      },
      queueModal: {
        title: { add: "Adicionar fila", edit: "Editar fila" },
        form: { name: "Nome", color: "Cor", greetingMessage: "Mensagem de saudação" },
        buttons: { okAdd: "Adicionar", okEdit: "Salvar", cancel: "Cancelar" },
        signatureRule: "Regra de assinatura",
      },
      userModal: {
        title: { add: "Adicionar usuário", edit: "Editar usuário" },
        form: { name: "Nome", email: "Email", password: "Senha", profile: "Perfil", whatsapp: "Conexão Padrão", canSeeUnassigned: "Ver chats não atribuídos", canViewPhones: "Pode ver números de telefone", canViewPhonesHelper: "Se desativado, este usuário vê os números dos contatos mascarados (ex. +549351●●●●482). Os administradores sempre os veem completos.", allowedWhatsapps: "Conexões permitidas", allowedWhatsappsAll: "Todas as conexões", allowedWhatsappsHelp: "Se não selecionar nenhuma, o usuário verá os chats de todas as conexões." },
        buttons: { okAdd: "Adicionar", okEdit: "Salvar", cancel: "Cancelar" },
        success: "Usuário salvo com sucesso.",
        signatureSectionTitle: "Assinatura de mensagens",
        signatureEnabledLabel: "Habilitar assinatura pessoal",
        signatureNameLabel: "Nome para exibir na assinatura (opcional)",
        signatureNameHelp: "Se vazio, é usado seu nome normal de usuário.",
        showName: "Incluir nome",
        showDepartment: "Incluir departamento (fila do ticket)",
        showCompany: "Incluir empresa",
        signaturePreviewLabel: "Visualização:",
        signaturePreviewDept: "[Departamento]",
        signaturePreviewCompany: "[Empresa]",
        signaturePreviewEmpty: "(sem componentes selecionados — equivalente a não assinar)",
        signaturePreviewDisabled: "(assinatura desativada)",
        signatureSanitizedWarning: "Caracteres especiais (* _ ~ `) foram removidos da sua assinatura. Esses caracteres quebram o formato e não são permitidos.",
        chipsVisibility: {
          title: "Estatísticas e dados do ticket",
          subtitle: "Mostre ou oculte as informações que aparecem em cada ticket da lista",
          attentionTime: {
            label: "Tempo de resposta (TDR)",
            tooltip: "Tempo que o cliente está esperando a nossa resposta",
          },
          clientSilence: {
            label: "Tempo sem resposta do cliente",
            tooltip: "Tempo desde a nossa última resposta sem que o cliente volte a escrever",
          },
          ticketAge: {
            label: "Antiguidade do ticket",
            tooltip: "Tempo total em que o ticket está aberto",
          },
          expiration: {
            label: "Expiração",
            tooltip: "Tickets próximos do fechamento automático",
          },
          contactState: {
            label: "Estado do contato",
            tooltip: "Estado comercial do contato (Novo, Ganho, Cliente, etc.)",
          },
          whatsappLine: {
            label: "Linha do WhatsApp",
            tooltip: "Conexão do WhatsApp pela qual o ticket entrou",
          },
          contactType: {
            label: "Tipo de cliente",
            tooltip: "Categoria atribuída ao contato",
          },
          queue: {
            label: "Departamento",
            tooltip: "Fila ou departamento atribuído ao ticket",
          },
          tags: {
            label: "Etiquetas",
            tooltip: "Etiquetas aplicadas ao ticket",
          },
        },
      },
      chatConnectionBar: {
        windowOpen: "Janela aberta",
        closesIn: "fecha em {{time}}",
        windowClosed: "Janela fechada",
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou pressione '/' para usar as respostas rápidas",
        placeholderClosed: "Reabra ou aceite este ticket para enviar uma mensagem.",
        metaWindowClosedPlaceholder: "Janela de 24h fechada — inicie com um template para escrever.",
        signMessage: "Assinar",
        includeName: "Incluir nome",
        captionPlaceholder: "Adicionar comentário...",
        cancelMedia: "Cancelar",
        sendMedia: "Enviar",
        dropFileHere: "Solte o arquivo aqui",
        lockReason: {
          company_disabled: "A assinatura está desativada nas configurações da empresa.",
          contact_forced: "Este contato está configurado para sempre assinar.",
          contact_blocked: "Este contato está configurado para nunca assinar.",
          type_forced: "Tipo de cliente está configurado para sempre assinar.",
          type_blocked: "Tipo de cliente está configurado para nunca assinar.",
          queue_forced: "A fila do ticket está configurada para sempre assinar.",
          queue_blocked: "A fila do ticket está configurada para nunca assinar.",
        },
      },
      scheduledMessages: {
        mode_button: "Agendar envio",
        queue_hint: "Mensagens na fila",
        max_reached: "Máximo 4 mensagens por envio programado",
        pick_datetime: "Quando enviar?",
        send_anyway_label: "Enviar mesmo que o contato responda",
        badge: "Agendado para {{datetime}}",
        cancelled_reply: "Envio agendado cancelado: o contato respondeu",
        cancelled_manual: "Envio agendado cancelado",
        cancel_action: "Cancelar mensagem agendada",
        sent_ok: "Mensagem agendada enviada",
        send_failed: "Não foi possível enviar a mensagem agendada",
        cancel: "Cancelar",
        invalid_past: "Data e hora devem ser futuras",
        was_scheduled: "Enviado como mensagem agendada",
        sending: "Enviando…",
        trace_by: "Agendado por {{name}}",
        trace_anon: "Agendado",
        trace_for: "para {{datetime}}",
        event_cancelled_manual: "Envio agendado cancelado pelo operador",
        event_cancelled_reply: "Envio agendado cancelado: o contato respondeu",
        event_cancelled_closed: "Envio agendado cancelado: o ticket foi fechado",
        event_cancelled_notfound: "Envio agendado cancelado: o ticket não existe mais",
        event_failed: "Não foi possível enviar a mensagem agendada",
        event_failed_window: "Não foi possível enviar: a janela de 24 h expirou",
        event_failed_partial: "{{sent}} de {{total}} enviados — o restante não pôde ser enviado",
      },
      signatureOnboarding: {
        message: "Sua empresa tem assinaturas de mensagens habilitadas. Configure sua assinatura pessoal para se identificar melhor com seus clientes.",
        configure: "Configurar",
        dismiss: "Descartar",
      },
      contactModal: {
        title: { add: "Adicionar contato", edit: "Editar contato" },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          numberHelp: "Apenas números com código do país. Ex: 5493513456789",
          numberOnlyDigits: "Apenas números são permitidos.",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          lastName: "Sobrenome",
          whatsappName: "Nome WhatsApp",
          company: "Empresa",
          kind: "Tipo de cliente",
          notes: "Notas",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
        statusSection: "Status do contato",
        moveTo_qualified: "Contatos",
        moveTo_pending: "Pendentes",
        moveTo_disqualified: "Descartados",
        movedToast: "Contato movido para {{tab}}",
        signatureMode: "Modo de assinatura",
        signatureModeDefault: "Padrão (usuário ou regras de tipo decidem)",
        signatureModeAlways: "Sempre assinar com este contato",
        signatureModeNever: "Nunca assinar com este contato",
      },
      contactTypeModal: {
        title: "Editar tipo de cliente",
        name: "Nome",
        color: "Cor",
        signatureRule: "Regra de assinatura",
        cancel: "Cancelar",
        save: "Salvar",
        savedOk: "Tipo de cliente atualizado",
        errNameRequired: "O nome é obrigatório",
      },
      deleteMessageModal: {
        title: "Deseja excluir esta mensagem?",
        forEveryone: "Excluir para todos",
        forMe: "Excluir para mim",
        cancel: "Cancelar",
        revokeFallbackToast: "A mensagem não pôde ser excluída para todos. Foi excluída apenas para você.",
      },
      settingsExtra: {
        // feat_347 — labels de los 8 tabs de /Settings
        // feat_352 — se fue `tabIa` (el tab se fusionó en automatizaciones) y entró
        // `tabReporteEmail`. Siguen siendo 8.
        tabNegocio: "Negócio",
        tabBandeja: "Caixa de entrada",
        tabMensajes: "Mensagens",
        tabAutomatizaciones: "Automações",
        tabReporteEmail: "Relatório por e-mail",
        tabClasificacion: "Classificação",
        tabIntegraciones: "Integrações e API",
        tabPermisos: "Permissões",
        // feat_351 — tab Permisos restyleado con el patrón visual canónico
        permisosSectionTitle: "Permissões dos atendentes",
        permisosSectionHelp: "Escolha o que um atendente, ou seja, qualquer usuário que não seja administrador, pode fazer nos chats. Os administradores sempre têm todas as permissões.",
        permisosDeleteChatLabel: "Permitir excluir chats",
        permisosDeleteChatHelp: "O atendente pode excluir um chat inteiro pelo menu do chat.",
        permisosDeleteChatTooltip: "Exclui o chat inteiro, com todas as suas mensagens, para toda a empresa. Não é reversível.",
        permisosDeleteMessageLabel: "Permitir excluir mensagens",
        permisosDeleteMessageHelp: "O atendente pode excluir mensagens individuais dentro de um chat.",
        permisosDeleteMessageTooltip: "Exclui uma mensagem do histórico do chat. Se a empresa a enviou e o WhatsApp ainda permitir, também é oferecido excluí-la para o cliente.",
        moreInfoAriaLabel: "Mais informações",
        // feat_339 — gate de carga de la página de Ajustes
        loadingSettings: "Carregando…",
        identidadAsistente: "Identidade do Assistente",
        // feat_353 — restyle del tab Negocio con el patrón de feat_351
        negocioIdentidadHelp: "Como a IA se apresenta e com quais dados fala da sua empresa.",
        negocioSedeLabel1: "Unidade 1",
        negocioSedePh1: "Ex: Central (Av. Naciones Unidas 346)",
        negocioSedeLabel2: "Unidade 2",
        negocioSedePh2: "Ex: Filial Norte",
        negocioHorarioHelp: "Base de horário usada pelo carrinho abandonado e pelos demais automatismos.",
        negocioAlways247Help: "A empresa é considerada sempre disponível.",
        negocioFeriadosHelp: "Dias em que a empresa não atende, mesmo que o horário diga que sim.",
        nombreNegocio: "Nome do negócio",
        phNombreNegocio: "Ex: Consultório Dental Gazzera",
        nombreAsistente: "Nome do assistente virtual",
        phNombreAsistente: "Ex: Lúcia",
        idioma: "Idioma",
        tonoAsistente: "Tom do assistente",
        tokenAPI: "Token de API",
        usarTokenDesc: "Use este token para conectar o WAIA com sistemas externos.",
        ocultarToken: "Ocultar token",
        mostrarToken: "Mostrar token",
        copiarToken: "Copiar token",
        tokenCopiado: "Token copiado",
        integracionIA: "Integração / IA",
        guardarConfig: "Salvar configurações",
        iaHabilitada: "IA habilitada",
        vendedorIA: "Agente IA",
        activo: "Ativo",
        inactivo: "Inativo",
        deshabilitadoAdmin: "Desabilitado pelo administrador",
        automatizacionTickets: "Automação de tickets",
        escenario1: "Cenário 1: Carrinho abandonado",
        descEscenario1: "O atendente ou a IA enviou a última mensagem, mas o cliente não respondeu. A IA é notificada via webhook para fazer acompanhamento.",
        escenario2: "Cenário 2: Sem atendimento",
        descEscenario2: "O cliente enviou a última mensagem mas a equipe não respondeu. Uma nota interna é adicionada ao ticket para alertar o atendente designado.",
        escenario3: "Cenário 3: Ticket esquecido",
        descEscenario3: "O atendente ou a IA enviou a última mensagem, o ticket tem um atendente designado e está aberto há muito tempo. O ticket é fechado automaticamente com uma nota interna.",
        activar: "Ativar",
        umbralHoras: "Limite de inatividade (horas)",
        rec4h: "Recomendado: 4 horas",
        rec2h: "Recomendado: 2 horas",
        rec24h: "Recomendado: 24 horas",
        configClasica: "Configuração clássica (fechamento por inatividade geral)",
        activarResolucion: "Ativar resolução automática por inatividade",
        resolverEn: "Resolver em (horas de inatividade)",
        ticketsSinActividad: "Tickets sem atividade por este tempo serão fechados",
        notificarCliente: "Notificar o cliente (minutos antes do fechamento)",
        sinNotificacion: "0 = sem notificação antes do fechamento",
        mensajeDespedida: "Mensagem de despedida ao cliente",
        phMensajeDespedida: "Olá, sua consulta foi encerrada por inatividade. Pode nos escrever quando quiser.",
        enviarAnteCierre: "Enviado ao cliente antes de fechar o ticket",
        notificarIA: "Notificar o sistema de IA ao fechar (para capturar o contexto)",
        continuidadConversacion: "Continuidade da conversa",
        descContinuidad: "Define quantos dias após o fechamento de um ticket ele pode ser reaberto se o cliente voltar a escrever. Com 0 dias, a conversa nunca é fragmentada: é sempre o mesmo ticket.",
        diasReapertura: "Dias de reabertura",
        tdrTitle: "Indicador de Tempo de Resposta (TDR)",
        tdrDesc: "Define os limites de alerta para o tempo de espera do cliente. O indicador muda de cor com base no tempo decorrido desde a última mensagem do cliente sem resposta da equipe.",
        tdrAmarilla: "Alerta amarelo (minutos)",
        tdrAmarillaDesc: "O indicador fica amarelo quando o cliente está aguardando por este tempo sem resposta.",
        tdrRoja: "Alerta vermelho (minutos)",
        tdrRojaDesc: "O indicador fica vermelho quando o cliente está aguardando por este tempo sem resposta.",
        tdrWarning: "⚠️ O limite amarelo deve ser menor que o limite vermelho.",
        tiposCliente: "Tipos de Cliente",
        nombreTipo: "Nome do tipo",
        sinTipos: "Sem tipos definidos",
        agregar: "Adicionar",
        motivosContacto: "Motivos de Contato",
        nombreMotivo: "Nome do motivo",
        sinMotivos: "Sem motivos definidos",
        copiar: "Copiar",
        copiado: "Copiado!",
        urlAutomatizacion: "URL de Automação",
        tokenAutomatizacion: "Token de Automação",
        timeoutSegundos: "Timeout (segundos)",
        reintentos: "Tentativas",
        promptAsistente: "Prompt do Assistente",
        firmaTitle: "Assinatura de mensagens",
        firmaEnabledLabel: "Habilitar assinatura para esta empresa",
        firmaEnabledHelp: "Quando ativo, os usuários podem assinar suas mensagens de saída com seu nome, departamento e/ou empresa. Cada usuário configura sua assinatura pessoal em seu perfil.",
        firmaReglaNoneOption: "Sem regra (o usuário decide)",
        firmaReglaAlwaysOption: "Sempre assinar",
        firmaReglaNeverOption: "Nunca assinar",
        firmaReglaPreferOnOption: "Sugerir assinar (switch padrão ON)",
        firmaReglaPreferOffOption: "Sugerir não assinar (switch padrão OFF)",
        firmaQuoteLabel: "Estilo de citação na assinatura",
        firmaQuoteHelp: "Se ativo, a assinatura é enviada como bloco de citação WhatsApp (verde indentado) para destacar-se da mensagem.",
        inboxModeSectionTitle: "Modo de caixa de entrada",
        inboxModeLabel: "Modo de caixa de entrada",
        inboxModeHelper: "Unificado mostra EM ATENDIMENTO e EM ESPERA em uma única lista ordenada por atividade.",
        inboxModeSplit: "Separado (duas sub-abas)",
        inboxModeUnified: "Unificado (estilo WhatsApp)",
        inboxOpenCount: "Em atendimento",
        inboxPendingCount: "Em espera",
        inboxOpenTooltip: "Chats com um atendente atribuído",
        inboxPendingTooltip: "Chats aguardando atendimento",
        inboxModeSmart: "Inteligente (órfãos em Espera)",
        inboxSmartAttendingTooltip: "Chats em atendimento + atribuídos pela IA",
        inboxSmartWaitingTooltip: "Chats sem departamento atribuído — requerem atenção humana",
        inboxSortLabel: "Ordem",
        inboxSortChrono: "Cronológico",
        inboxSortUrgent: "Urgentes primeiro",
        inboxUnansweredLabel: "Sem resposta",
        inboxUnansweredTooltip: "Mostra apenas chats onde o cliente escreveu e ninguém respondeu ainda",
        inboxUnansweredActive: "Filtrando: sem resposta",
        cancelScheduledOnReplyLabel: "Cancelar mensagens agendadas se o contato responder",
        markReadOnOpenSectionTitle: "Leitura de mensagens",
        markReadOnOpenLabel: "Marcar como lido ao abrir o chat",
        markReadOnOpenHelper: "Se ativado, as mensagens são marcadas como lidas assim que o atendente abre o chat. Se desativado, só são marcadas ao enviar uma resposta.",
        showUserFilterSectionTitle: "Filtro por usuário na bandeja",
        showUserFilterLabel: "Mostrar filtro por usuário (somente admins)",
        showUserFilterHelper: "Permite que admins filtrem a bandeja por um ou mais agentes atribuídos.",
        attendingModeSectionTitle: "Em atendimento por (indicador e bloqueio)",
        attendingModeLabel: "Modo",
        attendingModeOff: "Sem indicador",
        attendingModeVisual: "Mostrar quem está atendendo",
        attendingModeLock: "Mostrar e bloquear escrita alheia",
        attendingModeHelper: "\"Mostrar quem está atendendo\" adiciona um indicador \"EM ATENDIMENTO POR\" no cabeçalho e na lista quando um ticket aberto pertence a outro atendente. \"Bloquear escrita alheia\" também impede escrever nesse ticket. O dono do ticket e os administradores sempre podem escrever; os pendentes sem atribuição ficam livres.",
        closedPooledSectionTitle: "Resolvidos compartilhados (quem pode retomar)",
        closedPooledLabel: "Modo",
        closedPooledOff: "Isolado (cada um vê o seu)",
        closedPooledQueue: "Resolvidos compartilhados por fila",
        closedPooledCompany: "Resolvidos compartilhados em toda a empresa",
        closedPooledHelper: "Um atendimento resolvido continua aparecendo em Resolvidos de quem o resolveu. Este modo define quem MAIS pode encontrá-lo pela lupa e retomá-lo: ninguém (isolado), os atendentes da mesma fila, ou qualquer pessoa da empresa. Ao retomar, ele passa a EM ATENDIMENTO, fica atribuído a quem o pegou e vai para a fila dessa pessoa. Enquanto um humano atende, a IA não responde.",
        // feat_339 — desglose por modo, debajo de la intro de arriba
        closedPooledHelperOff: "Mais ninguém o vê. Cada atendente encontra apenas os atendimentos que ele mesmo resolveu.",
        closedPooledHelperQueue: "Veem-no os atendentes que compartilham essa fila. Ao retomá-lo, ele passa para a fila de quem o pegou.",
        closedPooledHelperCompany: "Vê-o qualquer pessoa da empresa, não importa a fila. Ideal se um cliente volta e o atende quem estiver livre.",
        // feat_343 — Resolver directo (cierra sin preguntar en qué quedó)
        directResolveSectionTitle: "Resolver direto",
        directResolveLabel: "Ao resolver um atendimento, fechá-lo direto — sem perguntar como terminou",
        directResolveHelper: "Com a chave desligada, ao tocar em Resolver pergunta-se se o contato foi ganho ou perdido. Com a chave ligada, Resolver fecha o atendimento de uma vez e o estado do contato fica como está.",
        outboundTypingSectionTitle: "Indicador \"digitando...\"",
        outboundTypingLabel: "Mostrar \"digitando...\" / \"gravando áudio...\" ao contato",
        outboundTypingHelp: "Quando um atendente digita ou grava um áudio, o contato vê no telefone dele (como no WhatsApp). Apenas conexões compatíveis; Meta mostra só \"digitando\" e requer uma mensagem recente do contato.",
        outboundTypingAiLabel: "Mostrar \"digitando...\" quando a IA responde",
        outboundTypingAiHelp: "Enquanto a inteligência artificial gera uma resposta, o contato vê \"digitando...\" no telefone dele. Faz a espera parecer natural.",
        autoReplyMediaSectionTitle: "Resposta automática a mídia",
        autoReplyMediaEnabledLabel: "Enviar uma desculpa quando chegam áudios, vídeos, imagens ou documentos",
        autoReplyMediaEnabledHelp: "Quando ativo, a IA não processa a mídia e é enviada uma única mensagem de cortesia após um breve debounce.",
        autoReplyMediaScopeLabel: "Quando responder",
        autoReplyMediaScopeAiOnly: "Apenas quando a IA deveria responder",
        autoReplyMediaScopeAlways: "Sempre (mesmo se um humano está atendendo o ticket)",
        autoReplyMediaTypesLabel: "Comportamento por tipo de mídia",
        autoReplyMediaTypeAudio: "Áudios (voz e anexos)",
        autoReplyMediaTypeVideo: "Vídeos",
        autoReplyMediaTypeImage: "Imagens",
        autoReplyMediaTypeDocument: "Documentos",
        autoReplyMediaTextAudio: "Texto para áudios",
        autoReplyMediaTextVideo: "Texto para vídeos",
        autoReplyMediaTextImage: "Texto para imagens",
        autoReplyMediaTextDocument: "Texto para documentos",
        autoReplyMediaTypeSticker: "Stickers",
        autoReplyMediaTypeReaction: "Reações (emojis e 👍)",
        autoReplyMediaTextSticker: "Texto para stickers",
        autoReplyMediaTextReaction: "Texto para reações",
        autoReplyMediaActionLabel: "Comportamento",
        autoReplyMediaActionAi: "Passar para IA",
        autoReplyMediaActionIgnore: "Ignorar",
        autoReplyMediaActionReply: "Responder com texto",
        autoReplyMediaReactionHelp: "As reações (👍 ❤️ etc.) são passadas para a IA como texto. A IA as interpreta como confirmações ou respostas.",
        autoReplyMediaTextGeneric: "Texto genérico (quando vários tipos chegam juntos)",
        autoReplyMediaTextPlaceholder: "Deixe vazio para usar o texto padrão no idioma da empresa.",
        autoReplyMediaTimeoutLabel: "Debounce (segundos)",
        autoReplyMediaTimeoutHelp: "Tempo de espera após o último áudio/vídeo/imagem/doc antes de enviar a resposta. Sugerido: 60.",
        emailReportSectionTitle: "📧 Relatórios por email",
        emailReportSectionDesc: "Quando uma fila fica sem resposta pelo tempo configurado, o sistema envia um email de relatório ao destinatário configurado.",
        emailReportQueues: "Filas de disparo",
        emailReportQueuesHelp: "O relatório é enviado quando um ticket dessas filas fica inativo pelo tempo configurado.",
        emailReportRecipients: "Destinatários do relatório",
        emailReportRecipientsHelp: "Separar com vírgulas. Ex: admin@empresa.com, suporte@empresa.com",
        emailReportTimeoutHours: "Horas de inatividade para enviar relatório",
        emailReportTimeoutHelp: "Tempo sem resposta do cliente antes de enviar o relatório.",
        emailReportSubjectTemplate: "Assunto do email",
        emailReportSubjectPlaceholder: "{wlName} - Relatório de ticket - {contactName}",
        emailReportHtmlTemplate: "Template HTML do email",
        emailReportHtmlHelp: "Você pode editar o modelo. O modelo atual do sistema é pré-carregado.",
        emailReportVarsTitle: "Variáveis disponíveis no assunto e template",
        emailReportVarsDesc: "{wlName} marca · {companyName} empresa · {contactName} nome contato · {contactPhone} telefone · {queueName} fila · {userName} atendente · {ticketId} · {closeReason} motivo · {aiSummary} resumo IA · {ticketLink} link · {closedAt} data · {wlLogoUrl} logo",
        emailReportTestLabel: "Email para envio de teste",
        emailReportTestBtn: "Enviar teste",
        emailReportTestSending: "Enviando...",
        emailReportTestSuccess: "✓ Email de teste enviado para {email}",
        emailReportTestError: "✗ Erro: {error}",
        emailReportSuperadminAllowed: "Permitir relatórios por email",
        emailReportSuperadminAllowedHelp: "Habilita a seção de configuração de relatórios por email para o admin da empresa.",
      },
      headerMetrics: {
        resueltos: "Chats fechados hoje pela sua equipe",
        atencionEspera: "Chats em atendimento ativo / aguardando resposta agora",
        tdr1ra: "Tempo médio desde a mensagem do cliente até a primeira resposta do atendente hoje",
        tdrResp: "Tempo médio de resposta por mensagem nos últimos 30 dias",
      },
      appointmentsSettings: {
        titulo: "Configurações de Consultas",
        empresa: "Empresa",
        general: "Geral",
        activarModulo: "Ativar módulo de consultas",
        contactarAdmin: "Para ativar ou desativar o módulo de consultas, entre em contato com o administrador do sistema.",
        canalWhatsapp: "Canal WhatsApp para avisos",
        principalAuto: "Principal (automático)",
        tiposCita: "Tipos de consulta",
        tiposCitaDesc: "O atendente escolhe o tipo ao agendar. Seja específico.",
        cargarEjemplos: "Carregar exemplos",
        nuevoTipo: "Novo tipo",
        agregar: "Adicionar",
        avisosAutomaticos: "Avisos automáticos",
        aviso1: "Aviso 1 — 24 horas antes",
        aviso2: "Aviso 2 — Início do dia da consulta",
        aviso3: "Aviso 3 — Pouco antes da consulta",
        textoMensaje: "Texto da mensagem",
        minutosAntes: "Minutos antes",
        horaAviso: "Hora do aviso",
        notaAviso2: "Nota: Se a consulta for logo no início e o aviso 3 cair dentro dos 30 minutos seguintes, este aviso será omitido automaticamente.",
        guardarConfig: "Salvar configurações",
        errorGuardar: "Erro ao salvar",
        configGuardada: "Configurações salvas",
      },
      bulkImport: {
        cancelButton: "Cancelar",
        cancelConfirmTitle: "Cancelar envio?",
        cancelConfirmBody: "Este envio será parado definitivamente. Não poderá ser retomado.",
        cancelSuccess: "Envio cancelado",
        cancelError: "Não foi possível cancelar o envio",
      },
      bulkSend: {
        // feat_210 estándar — Excel modelo + preview por cantidad de variables
        standard: {
          downloadTemplate: "Baixar modelo de Excel",
          downloadFileName: "modelo-envio-em-massa.xlsx",
          byVarCountTitle: "Linhas válidas conforme o modelo que você escolher",
          byVarCount: "Com um modelo de {{n}} variáveis: {{count}} linhas válidas",
          byVarCountOne: "Com um modelo de 1 variável: {{count}} linhas válidas",
          noValidAny: "Nenhuma linha serve com nenhum modelo. Revise o arquivo.",
          missingRequired: "Faltam colunas obrigatórias no arquivo: {{columns}}",
          missingForTemplate: "Este modelo usa {{n}} variáveis e no arquivo falta: {{columns}}",
          missingInRows: "Falta {{column}} em {{count}} linhas",
          ruleDiscarded: "A regra da coluna {{column}} descartou {{count}} linhas",
          checking: "Verificando o arquivo com este modelo…",
          tplValid: "Com este modelo: {{count}} linhas válidas de {{total}}",
          tplNoValid: "Com este modelo não sobra nenhuma linha válida.",
          varsExceed: "O modelo tem {{tpl}} variáveis e o arquivo padrão admite até {{max}}. Escolha um modelo com menos variáveis.",
          noSample: "A amostra aparece ao escolher o modelo.",
        },
        steps: { upload: "Arquivo", preview: "Prévia", template: "Modelo", options: "Opções", confirm: "Confirmar" },
        history: {
          title: "Histórico de envios",
          viewHistory: "Ver histórico de envios",
          backToWizard: "Voltar ao assistente",
          backToList: "Voltar ao histórico",
          columnDate: "Data", columnFile: "Arquivo", columnStatus: "Status", columnProgress: "Progresso",
          loadMore: "Carregar mais", empty: "Ainda não foi feito nenhum envio.",
        },
        back: "Voltar",
        next: "Avançar",
        upload: {
          hint: "Arraste ou clique para enviar seu arquivo Excel (.xlsx)",
          choose: "Escolher arquivo",
          selected: "Arquivo: {{name}}",
          readError: "Não foi possível ler o arquivo",
        },
        preview: {
          total: "Linhas totais", valid: "Válidas", skipped: "Descartadas",
          skFilter: "Por filtro", skPhone: "Telefone inválido", skDup: "Duplicadas",
          sample: "Amostra (primeiras linhas normalizadas)",
          colName: "Nome", colPhone: "Telefone", colVars: "Variáveis",
          noValid: "Não há linhas válidas para enviar. Verifique o arquivo e os filtros do perfil.",
        },
        template: {
          connLabel: "Conexão Meta", noConn: "Não há conexões Meta conectadas nesta empresa.",
          tplLabel: "Modelo aprovado", noTpl: "Esta conexão não tem modelos aprovados.",
          lastUsedHint: "usado por último",
          varsTitle: "Prévia da mensagem (com a primeira linha)",
          varMismatch: "O modelo tem {{tpl}} variáveis mas o perfil monta {{prof}}. Escolha um modelo com a mesma quantidade.",
        },
        options: {
          throttle: "Segundos entre envios", throttleHelp: "Pausa entre cada mensagem (1 a 60 segundos).",
          contextModeLabel: "Modo de contexto",
          contextModeNormal: "Normal",
          contextModeTurnosia: "TurnosIA (convite para agendar)",
          contextModeHint: "Como o assistente é avisado sobre o que se trata este envio. No modo TurnosIA, além de enviar o modelo, informa-se ao assistente que o contato foi convidado a agendar um horário.",
          optIn: "Confirmo que os destinatários deram consentimento para receber mensagens.",
          overwriteTitle: "Atenção: este envio sobrescreve dados existentes",
          overwrite: "Se algum destinatário já existir como contato no WAIA, este envio vai sobrescrever suas notas e reatribuir o assistente, a fila e o status definidos neste perfil. Confirme se este comportamento é o desejado.",
        },
        confirm: {
          title: "Revise antes de enviar", file: "Arquivo", validRows: "Linhas a enviar",
          conn: "Conexão", tpl: "Modelo", throttle: "Pausa entre envios",
          warnBrief: "Lembre: os contatos existentes são sobrescritos (notas, assistente, fila, status).",
          send: "Confirmar e enviar", sentOk: "Envio iniciado",
        },
        dedupe: {
          msg: "Um arquivo idêntico já foi enviado em {{date}}. Enviar mesmo assim?",
          confirm: "Enviar mesmo assim", cancel: "Cancelar",
        },
        result: {
          title: "Resultado do envio", pending: "Na fila", processing: "Processando",
          completed: "Concluído", pausedMeta: "Pausado (Meta)", failed: "Falhou", cancelled: "Cancelado",
          sent: "Enviados", failedC: "Falharam", skipped: "Descartados", total: "Total",
          pausedExplain: "O envio foi pausado porque a Meta rejeitou 5 mensagens seguidas. Verifique a conexão e tente novamente os que falharam.",
          retry: "Repetir falhados", retrying: "Repetindo...", retryDone: "{{n}} linhas recolocadas na fila",
          newImport: "Novo envio", rowsTitle: "Detalhe por linha", colStatus: "Status", colDetail: "Detalhe",
          rowStatus: {
            pending: "Na fila", sent: "Enviado", failed: "Falhou",
            skipped_filter: "Descartada (filtro)", skipped_invalid_phone: "Telefone inválido",
            skipped_dup_in_batch: "Duplicada", skipped_optout: "Sem consentimento",
          },
        },
      },
      cargaDeDatos: {
        menuTitle: "Carga de Dados",
        empty: "Nenhum formulário configurado",
        loading: "Carregando...",
        errorLoading: "Erro ao carregar o formulário",
      },
      metaTemplates: {
        drawerTitle: "Templates Meta",
        tabMine: "Meus templates",
        tabSend: "Enviar template",
        syncButton: "Sincronizar",
        syncSuccess: "{{count}} templates sincronizados",
        syncError: "Erro ao sincronizar templates",
        newButton: "Novo template",
        noTemplates: "Nenhum template. Clique em Sincronizar para carregar do Meta.",
        deleteConfirm: "Excluir este template no Meta e no sistema?",
        deleteSuccess: "Template excluído",
        deleteError: "Erro ao excluir template",
        createSuccess: "Template enviado ao Meta para aprovação",
        createError: "Erro ao criar template",
        sendSuccess: "Template enviado",
        sendError: "Erro ao enviar template",
        form: {
          name: "Nome (snake_case, sem espaços)",
          category: "Categoria",
          language: "Idioma",
          headerType: "Cabeçalho (opcional)",
          headerFormat: "Tipo de cabeçalho",
          headerFormats: {
            NONE: "Nenhum",
            TEXT: "Texto",
            IMAGE: "Imagem",
            DOCUMENT: "Documento",
            VIDEO: "Vídeo",
          },
          headerSample: "Arquivo de amostra",
          headerSampleNotice:
            "Este arquivo é apenas um exemplo para que a Meta aprove o modelo. Em cada envio você vai escolher o arquivo real (a fatura, o orçamento, etc.).",
          headerSampleChoose: "Escolher arquivo de amostra",
          pendingNotice:
            "O modelo fica pendente até a Meta aprovar. A aprovação pode demorar; o status é atualizado ao sincronizar.",
          headerText: "Texto do cabeçalho",
          body: "Corpo da mensagem",
          bodyHint: "Use {{1}}, {{2}}, etc. para variáveis",
          examplesHint: "A Meta exige um exemplo para cada variável para aprovar o template.",
          exampleFor: "Exemplo para {{var}}",
          varsNotSequential: "As variáveis devem ser sequenciais a partir de {{1}} (sem saltos).",
          footer: "Rodapé (opcional)",
          submit: "Criar template",
          cancel: "Cancelar",
        },
        suggested: {
          useButton: "Usar modelo sugerido",
          listTitle: "Modelos sugeridos (prontos para aprovação)",
          approvalNotice:
            "Estes modelos passam pela aprovação da Meta, mas por serem pré-validados costumam ser aprovados rapidamente. Você pode editar o texto e os exemplos antes de criar.",
          names: {
            retomar_conversacion: "Retomar conversa",
            recordatorio_cita: "Lembrete de consulta",
            seguimiento_general: "Acompanhamento",
            aviso_disponible: "Aviso de novidades",
            reapertura_24h: "Reabertura após 24h",
          },
        },
        categories: {
          MARKETING: "Marketing",
          UTILITY: "Utilitário",
          AUTHENTICATION: "Autenticação",
        },
        languages: {
          es: "Espanhol",
          en: "Inglês",
          pt: "Português",
          it: "Italiano",
        },
        status: {
          APPROVED: "Aprovado",
          PENDING: "Pendente",
          REJECTED: "Rejeitado",
          PAUSED: "Pausado",
          DELETED: "Excluído",
          DISABLED: "Desabilitado",
          IN_APPEAL: "Em recurso",
          REINSTATED: "Restaurado",
          LIMIT_EXCEEDED: "Limite excedido",
          PENDING_DELETION: "Pendente de exclusão",
        },
        sendForm: {
          pausedManualNotice: "A linha está pausada para envios automáticos. Este envio manual será enviado.",
          attachment: "Anexo",
          attachmentChoose: "Escolher arquivo",
          attachmentHint: {
            DOCUMENT: "Este modelo envia um documento: escolha o arquivo real (PDF, Word ou Excel).",
            IMAGE: "Este modelo envia uma imagem: escolha o arquivo real.",
            VIDEO: "Este modelo envia um vídeo: escolha o arquivo real.",
          },
          selectTemplate: "Selecione um template aprovado",
          toNumber: "Número de destino (com código do país)",
          variables: "Variável {{index}}",
          submit: "Enviar",
          noApproved: "Nenhum template aprovado",
        },
        windowBanner: {
          message: "⏰ Janela de 24h fechada. O contato deve escrever primeiro, ou inicie a conversa com um template.",
          sendTemplate: "Enviar template",
        },
        inline: {
          selectLabel: "Escolha um template",
          noApproved: "Você ainda não tem templates aprovados. Crie um para iniciar a conversa.",
          createButton: "Criar template",
          previewLabel: "Prévia",
          sendButton: "Enviar template",
          sentTitle: "Template enviado",
          sendAnother: "Enviar outro",
        },
      },
      embeddedSignup: {
        title: "Conectar WhatsApp Business",
        connectButton: "Conectar com Meta",
        manualButton: "Inserir dados manualmente",
        connecting: "Conectando...",
        success: "Conexão criada com sucesso",
        error: "Erro ao conectar com Meta",
        connectionName: "Nome da conexão",
        emptyMetaError: "Complete a conexão com Meta (botão Conectar com Meta) ou insira os dados manualmente. Não é possível criar uma conexão Meta vazia.",
        cancelled: "Conexão com Meta cancelada.",
      },
      batchSelection: {
        exit: "Sair da seleção",
        count: "{{count}} selecionados",
        markRead: "Marcar como lido",
        resolve: "Resolver",
        transfer: "Transferir",
        delete: "Excluir",
        restore: "Restaurar",
        hardDelete: "Excluir definitivamente",
        more: "Mais ações",
        selectAllVisible: "Selecionar todos os visíveis",
        toast: {
          markReadOk: "{{count}} chats marcados como lidos",
          markReadPartial: "Marcados como lidos {{processed}} de {{total}} ({{skipped}} ignorados)",
          resolveOk: "{{count}} chats resolvidos",
          resolvePartial: "Resolvidos {{processed}} de {{total}} ({{skipped}} ignorados)",
          transferOk: "{{count}} chats transferidos",
          transferPartial: "Transferidos {{processed}} de {{total}} ({{skipped}} ignorados)",
          restoreOk: "{{count}} chats restaurados",
          restorePartial: "Restaurados {{processed}} de {{total}} ({{skipped}} ignorados)",
          deletedWithUndo: "{{count}} chats enviados para Excluídos",
          undo: "Desfazer",
          undoOk: "Restauração aplicada",
          hardDeleteOk: "{{count}} chats excluídos permanentemente",
          hardDeletePartial: "Excluídos definitivamente {{processed}} de {{total}} ({{skipped}} ignorados)",
        },
      },
      resolveTicketDialog: {
        title: "Como ficou esta conversa?",
        batchCount: "Você vai resolver {{count}} chats.",
        won: "Ganho",
        lost: "Perdido",
        noChange: "Sem mudança — resolver mesmo assim",
      },
      batchTransferDialog: {
        title: "Transferir chats",
        subtitle: "Você vai transferir {{count}} chats para um departamento.",
        queueLabel: "Departamento destino",
        queuePlaceholder: "Selecionar departamento...",
        cancel: "Cancelar",
        confirm: "Transferir",
      },
      batchDeleteDialog: {
        title: "Excluir chats",
        body: "Você vai excluir {{count}} chats. Pode restaurá-los em Excluídos.",
        cancel: "Cancelar",
        confirm: "Excluir",
      },
      batchHardDeleteDialog: {
        title: "Excluir definitivamente",
        body: "Isso excluirá {{count}} chats permanentemente. Não é possível desfazer.",
        bodySingle: "Isso excluirá este chat permanentemente. Não é possível desfazer.",
        cancel: "Cancelar",
        confirm: "Excluir definitivamente",
      },
      quotedMessage: {
        sticker: "Figurinha",
        image: "Imagem",
        video: "Vídeo",
        audio: "Mensagem de voz",
        document: "Documento",
        vcard: "Contato",
        location: "Localização",
        attachment: "Anexo",
      },
      mediaPlaceholder: {
        sticker: "Figurinha",
        image: "Imagem",
        video: "Vídeo",
        audio: "Mensagem de voz",
        document: "Documento",
        attachment: "Anexo",
      },
      documentPreview: {
        download: "Baixar",
        openInNew: "Abrir em nova aba",
        previewFailed: "Não foi possível carregar a pré-visualização",
      },
      ticketPresence: {
        composing: "Digitando...",
        recording: "Gravando áudio...",
        composingNamed: "{{name}} está digitando...",
        recordingNamed: "{{name}} está gravando áudio...",
        composingSomeone: "Alguém está digitando...",
        recordingSomeone: "Alguém está gravando áudio...",
      },
      ticketAttending: {
        header: "Em atendimento por {{name}}",
        // feat_340: sin uso — el zócalo ahora muestra solo el primer nombre del asesor.
        chip: "Atende {{name}}",
        locked: "Em atendimento por {{name}} — você não pode escrever",
        someone: "outro atendente",
      },
      cartAbandonedSchedule: {
        modeLabel: "Quando enviar o aviso de carrinho abandonado?",
        always: "Sempre (sem restrição de horário)",
        businessHours: "Somente no horário comercial da empresa",
        custom: "Horário personalizado para carrinhos",
        helperAlways: "O aviso é enviado a qualquer momento em que a inatividade for detectada.",
        helperBusinessHours: "Se a empresa estiver fora do horário ao detectar o abandono, o aviso é automaticamente adiado para a próxima execução dentro do horário comercial.",
        helperCustom: "Defina um horário próprio para os avisos de carrinho abandonado, independente do horário comercial.",
        customScheduleLabel: "Horário personalizado para avisos de carrinho abandonado",
        warningNoBusinessHours: "⚠ Você não tem horário comercial configurado. O aviso de carrinho abandonado não será enviado até que você o configure na seção Horário comercial.",
        goToBusinessHours: "Ir para Horário comercial",
      },
      welcomeNotice: {
        sectionTitle: "Mensagem de boas-vindas uma única vez",
        sectionHelp: "Para uma mensagem que a IA deve dizer uma única vez por contato (por exemplo: «Estamos estreando um sistema novo e cadastrando cada cliente uma única vez»).",
        enabledLabel: "Lembrar para quem já foi mostrada",
        enabledHelp: "A IA recebe se o contato já a viu e se é um cliente conhecido.",
        enabledTooltip: "Com isto ativado, cada mensagem que chega à IA informa se o contato já recebeu a mensagem de boas-vindas e se já é um cliente cadastrado. A IA precisa estar configurada para não repeti-la. O contato fica marcado quando a IA a envia (se coincidir com as frases abaixo) ou quando a IA avisa que a mostrou. Um admin pode limpar a marca na ficha do contato.",
        matchLabel: "Frases que identificam a mensagem",
        matchPlaceholder: "sistema novo|cadastrando cada cliente",
        matchHelp: "Separadas por «|». Quando a IA envia uma mensagem que contém alguma, o contato fica marcado. Maiúsculas e acentos não importam. Vazio = só a IA marca.",
        blockLabel: "A IA não escreve se o chat já tem atendente",
        blockHelp: "Se um atendente assumiu o chat, a resposta da IA que chegar depois não é enviada.",
        blockTooltip: "Evita que a IA responda segundos depois de um atendente já ter respondido (a resposta da IA já estava a caminho). Com isto ativado, se o chat tem um atendente atribuído e não está fechado, a resposta da IA é descartada e não chega ao cliente.",
        contactTitle: "Mensagem de boas-vindas",
        contactSent: "Já recebeu em {{date}}",
        contactNotSent: "Ainda não recebeu",
        resetButton: "Mostrar de novo",
        resetConfirmTitle: "Mostrar a mensagem de boas-vindas de novo?",
        resetConfirmBody: "A IA poderá dizer a mensagem de boas-vindas de novo a este contato na próxima saudação.",
        resetDone: "Pronto, o contato vai receber a mensagem de boas-vindas de novo.",
      },
      holidays: {
        title: "Feriados",
        nationals: "Feriados nacionais",
        nationalsHelp: "Ative o interruptor se sua empresa trabalha nesse feriado.",
        customs: "Feriados próprios",
        noCustoms: "Nenhum feriado próprio.",
        works: "Trabalhamos",
        closed: "Fechado",
        recurring: "todo ano",
        addCustom: "Adicionar feriado",
        confirmDelete: "Excluir este feriado?",
        dateLabel: "Data",
        nameLabel: "Nome",
        recurringLabel: "Repete todos os anos",
        recurringHelp: "",
        cancel: "Cancelar",
        save: "Salvar",
        saveOk: "Feriado salvo",
        nameHelp: "O motivo que o cliente verá. Ex.: Festa do padroeiro.",
        scopeLabel: "Abrangência (opcional)",
        scopeHelp: "Onde vale. Ex.: «só Córdoba». Vazio = geral.",
        messageLabel: "Mensagem para o cliente (opcional)",
        messageHelp: "Substitui a mensagem geral deste dia. Você pode usar {motivo}, {fecha_reapertura} e {alcance}.",
        edit: "Editar",
        delete: "Excluir",
        editTitle: "Editar feriado",
        editNote: "Abrangência e mensagem",
        nationalNoteHelp: "Este feriado nacional continua fechando a empresa. Aqui você pode adicionar a abrangência e uma mensagem para o cliente.",
        hasMessage: "Tem mensagem própria",
        noticeTitle: "Aviso de feriados ao cliente",
        noticeDescription: "Quem escreve pelo WhatsApp fica sabendo qual dia é feriado, por quê e quando o atendimento volta.",
        noticeEnabledLabel: "Avisar feriados ao cliente que consulta",
        noticeEnabledHelp: "A IA recebe os feriados; sem IA, o WAIA responde com um aviso.",
        noticeEnabledTooltip: "Ligado: se a empresa tem IA, a IA recebe os feriados dos próximos 30 dias (motivo, abrangência e retorno) para avisar o cliente quando pergunta por esses dias ou prazos de entrega. Se nenhuma IA vai responder (sem IA, IA desligada ou um atendente responsável), no dia do feriado o WAIA responde automaticamente com a mensagem abaixo, uma vez por contato e por dia. Nunca para grupos.",
        noticeTemplateLabel: "Mensagem do dia de feriado",
        noticeTemplateHelp: "Vazio = mensagem padrão. Variáveis: {motivo}, {fecha_reapertura}, {alcance}.",
        noticeDefault: "Olá 👋 Hoje estamos fechados por {motivo}. Retomamos o atendimento {fecha_reapertura}. Responderemos assim que voltarmos.",
        upcomingTitle: "Próximos feriados (30 dias)",
        upcomingHelp: "É o que a IA recebe e o que o aviso automático usa.",
        upcomingNone: "Não há feriados nos próximos 30 dias.",
        today: "Hoje",
        reopens: "retoma {{when}}",
        refresh: "Atualizar",
        sampleLabel: "Assim ficaria o aviso em {{date}}:",
      },
      weeklySchedule: {
        addRange: "Adicionar faixa",
        removeRange: "Remover faixa",
        to: "às",
        days: {
          monday: "Segunda",
          tuesday: "Terça",
          wednesday: "Quarta",
          thursday: "Quinta",
          friday: "Sexta",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      emailReportTimerMode: {
        label: "A partir de quando contar o tempo para o relatório?",
        updatedAt: "Desde a última mensagem enviada ou recebida",
        updatedAtHelp: "O contador é reiniciado a cada nova mensagem no ticket, incluindo respostas automáticas da IA.",
        createdAt: "Desde o início da conversa (T0)",
        createdAtHelp: "O contador não reinicia com atividade automática. O email chega sempre {{hours}}h após a primeira mensagem, independentemente da tentativa de recuperação da IA.",
      },
      metaErrorCodes: {
        "-100": "Não enviada: os envios desta conexão estavam pausados.",
        tooltipPrefix: "Falha na entrega",
        131042: "Falta método de pagamento na Meta (Central de Faturamento).",
        131047: "Janela de 24h fechada — é necessário um modelo aprovado.",
        131026: "O número não tem WhatsApp ou a mensagem não pôde ser entregue.",
        131051: "Tipo de mensagem não suportado pela Meta.",
        132000: "O modelo não corresponde às variáveis enviadas.",
        132001: "O modelo não existe ou foi excluído.",
        132005: "O modelo está pausado pela Meta.",
        132007: "O modelo foi desativado pela Meta.",
        132012: "Formato de variável do modelo inválido.",
        133010: "O número não está registrado na WhatsApp Cloud API.",
        default: "Erro de entrega da Meta (código {{code}}).",
        default_unknown: "Erro de entrega da Meta.",
      },
      // feat_299 — "Ver como usuário". Namespace próprio: NÃO reutilizar
      // `impersonate` (painel superadmin), é outra coisa.
      viewAs: {
        menuLabel: "Ver como usuário",
        modalTitle: "Ver como usuário",
        searchPlaceholder: "Buscar usuário...",
        cancel: "Cancelar",
        noUsers: "Nenhum usuário disponível",
        banner: "Visualizando como {{name}}",
        exit: "Sair",
        activated: "Agora visualizando como {{name}}",
      },
      // feat_316 — preferências de notificação por usuário
      notificationPrefs: {
        title: "Notificações",
        active: "Ativadas",
        mutedPermanent: "Silenciadas",
        snoozedUntil: "Silenciadas até às {{time}}",
        snoozeFor: "Silenciar por:",
        untilOpening: "Até abrirmos",
        mutePermanent: "Silenciar até eu reativar",
        sound: "Som",
        browser: "Notificação do navegador",
        browserBlocked: "O navegador bloqueou as notificações. Habilite-as no cadeado da barra de endereços.",
        browserDenied: "A permissão não foi concedida. Você pode habilitá-la no cadeado da barra de endereços.",
        badgeNote: "Silenciar afeta o som e o aviso do navegador. O contador e a lista de conversas continuam atualizando.",
      },
      contactPriority: {
        label: "Prioridade de notificação",
        normal: "Normal",
        priority: "Prioritário (sempre notifica)",
        muted: "Silenciado (nunca notifica)",
        help: "\"Prioritário\" notifica mesmo com as notificações silenciadas. \"Silenciado\" nunca notifica.",
      },
      // feat_333 — modo WAIAenvios (rótulo do switch no painel superadmin)
      waiaEnvios: {
        switchLabel: "WAIAenvios — apenas envios por modelo",
        switchHelp: "Deixa o painel apenas com Conexões e Carga de Dados. O cliente responde pelo próprio telefone.",
      },
      // Boundary de módulo (feat_364). Se o TurnosIA falhar, falha SÓ o TurnosIA.
      errorBoundary: {
        routeTitle: "Esta tela não pôde ser exibida",
        routeHelp: "Tente outra seção do menu, ou recarregue a página.",
        moduleTitle: "Esta seção não está disponível no momento",
        moduleHelp: "O restante do WAIA continua funcionando normalmente. Se acontecer de novo, avise o suporte.",
        appTitle: "Algo deu errado",
        appHelp: "Recarregue a página para continuar.",
        inline: "Não foi possível exibir esta parte.",
        retry: "Tentar de novo",
        reload: "Recarregar a página",
      },
      contactImportCsv: {
        title: "Importar contatos de CSV",
        columnN: "Coluna {{n}}",
        steps: {
          file: "Arquivo",
          columns: "Colunas",
          options: "Opções",
          result: "Resultado",
        },
        file: {
          help: "Exporte sua planilha como CSV (no Excel: Arquivo → Salvar como → CSV). Aceitamos separador vírgula, ponto e vírgula, tabulação ou barra, com ou sem linha de títulos.",
          drop: "Arraste o arquivo aqui ou clique para escolher",
          limits: "Arquivos .csv ou .txt · até 5 MB · até 10.000 linhas",
          noMessages: "Importar não envia nenhuma mensagem aos contatos.",
        },
        columns: {
          summary: "{{file}} · {{rows}} linhas",
          delimiter: "Separador",
          encoding: "Codificação",
          hasHeader: "A primeira linha tem os títulos",
          mapHelp: "Escolha a qual dado do WAIA corresponde cada coluna. As colunas não escolhidas são ignoradas.",
          numberRequired: "Escolha qual coluna tem o número de telefone: é obrigatória.",
          previewNote: "Prévia: {{shown}} de {{total}} linhas.",
        },
        delimiters: {
          comma: "Vírgula ( , )",
          semicolon: "Ponto e vírgula ( ; )",
          tab: "Tabulação",
          pipe: "Barra ( | )",
        },
        encodings: {
          utf_8: "UTF-8",
          utf_8_bom: "UTF-8 com BOM",
          windows_1252: "Latin-1 / Windows (Excel)",
          utf_16le: "UTF-16 LE",
          utf_16be: "UTF-16 BE",
        },
        fields: {
          ignore: "Ignorar",
          name: "Nome",
          lastName: "Sobrenome",
          number: "Número (WhatsApp)",
          email: "E-mail",
          organization: "Empresa / organização",
          notes: "Notas",
          tags: "Etiquetas",
          extra: "Campo extra (com o título da coluna)",
        },
        options: {
          country: "País padrão dos números",
          countryHelp: "Usado para números sem código do país. Na Argentina, o 549 é adicionado e o 0 e o 15 são removidos.",
          duplicates: "Se o número já existe nos seus contatos",
          dupSkip: "Ignorá-lo (não alterar o contato existente)",
          dupFill: "Completar apenas os campos vazios",
          dupHelp: "Um dado já preenchido nunca é substituído.",
          tag: "Adicionar uma etiqueta a todos os importados",
          tagName: "Nome da etiqueta",
          tagDefault: "Importado {{date}}",
          confirm: "Serão processadas {{rows}} linhas. Nenhuma mensagem é enviada.",
        },
        result: {
          created: "Criados",
          updated: "Atualizados",
          skipped: "Ignorados",
          invalid: "Inválidos",
          rejectedTitle: "{{n}} linhas não foram importadas",
          download: "Baixar CSV com o motivo",
          line: "Linha",
          reason: "Motivo",
          moreInFile: "São mostradas as primeiras 50. O CSV para baixar tem todas.",
          allOk: "Todas as linhas foram importadas.",
          tagsIgnored: "{{n}} etiquetas novas não foram criadas (máximo 50 por importação).",
          rejectedFileName: "contatos-nao-importados.csv",
        },
        buttons: {
          cancel: "Cancelar",
          back: "Voltar",
          next: "Avançar",
          import: "Importar",
          close: "Fechar",
        },
      },
    },
  },
};

export { messages };
